import React, { useRef, useState, useEffect } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faCheck, faCar, faTruck, faTachometerAlt, faReply, faWalking, faBiking, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import CircularProgress from '@material-ui/core/CircularProgress';
import '../../css/export.css';
import Cookies from 'js-cookie';
import API_PATH from "../../constants/config.json";
import { setCookie, clearCookie, getPrivileges } from '../../functions/Auth';
const API_URL = process.env.REACT_APP_BASE_URL;
const axios = require('axios');
const AWS = require('aws-sdk');

//Start Css code ...
const useStyles = makeStyles((theme) => ({
    ExternalMainBlock: {
        width: '100%',
        zIndex: '22111',
        float: 'left',
        position: 'absolute',
        top: '50px',
        background: 'rgba(0,0,0,.5)',
        left: '0',
    },
    mainBlock: {
        position: 'relative',
        border: '1px solid #24618E',
        margin: '0 auto',
        borderRadius: '5px',
        background: '#fff',
        padding: '10px',
        paddingBottom: '10px',
        '@media only screen and (max-width: 3500px)': {
            width: '700px',
        },
        '@media only screen and (min-width: 3501px)': {
            width: '1200px',
            '& span.mark.consiMark': {
                marginTop: '4px',
            }
        },
        '& h3': {
            color: '#24618E',
            margin: '0',
            '@media only screen and (max-width: 3500px)': {
                fontSize: '20pt',
            },
            '@media only screen and (min-width: 3501px)': {
                fontSize: '30pt',
            },
        },
        '& hr': {
            border: '1px solid #00A75D',
            borderBottom: 'none',
            marginTop: '0px',
        }
    },
    closeIcom: {
        position: 'absolute',
        margin: 0,
        top: '10px',
        cursor: 'pointer',
        color: '#24618E',
        textAlign: 'center',
        '& :hover': {
            color: '#CC0000',
        },
        '@media only screen and (max-width: 3500px)': {
            right: '10px',
            width: '25px',
            fontSize: '20pt',
        },
        '@media only screen and (min-width: 3501px)': {
            right: '20px',
            width: '40px',
            fontSize: '30pt',
        },
    },
    fieldsetname: {
        width: '100%',
        border: '1px solid #00A75D',
        margin: '0px',
        padding: '10px',
        borderRadius: '5px',
        marginBottom: '10px',
        '& .MuiPaper-elevation1': {
            boxShadow: 'none',
        },
        '& legend': {
            marginLeft: '10px',
        },
        '& fieldset.MuiFormControl-root': {
            width: '100%',
            float: 'left',
            display: 'inline-block',
        }
    },
    stationIdDataPara: {
        margin: '0',
        width: '100%',
        float: 'left',
        '& .MuiFormControlLabel-label': {
            fontSize: '14pt',
            color: '#333',
            position: 'relative',
            top: '3px',
        }
    },
    btnBlock: {
        width: '100%',
        float: 'left',
        textAlign: 'center',
        paddingTop: '20px',
        '@media only screen and (min-width: 3501px)': {
            paddingBottom: '10px',
        },
    },
    exportBackBtn: {
        background: '#fff',
        color: '#333',
        padding: '5px 25px',
        border: '1px solid #333',
        borderRadius: '5px',
        cursor: 'pointer',
        '@media only screen and (max-width: 3500px)': {
            width: '160px',
        },
        '@media only screen and (min-width: 3501px)': {
            width: '180px',
        },
    },
    exportDisabledBtn: {
        background: '#fff',
        color: 'rgba(0, 0, 0, 0.26)',
        padding: '5px 25px',
        border: '1px solid rgba(0, 0, 0, 0.12);',
        borderRadius: '5px',
        cursor: 'pointer',
        '@media only screen and (max-width: 3500px)': {
            width: '160px',
        },
        '@media only screen and (min-width: 3501px)': {
            width: '180px',
        },
    },
    exportNextBtn: {
        background: '#24618E',
        color: '#fff',
        padding: '5px 25px',
        border: '1px solid #24618E',
        borderRadius: '5px',
        cursor: 'pointer',
        '@media only screen and (max-width: 3500px)': {
            width: '160px',
        },
        '@media only screen and (min-width: 3501px)': {
            width: '180px',
        },
    },
    dataTableblock: {
        width: '100%',
        float: 'left',
        padding: '5px',
        border: '1px solid #888',
        marginTop: '-5px',
    },
    tableScreen: {
        width: '100%',
        float: 'left',
        overflowY: 'scroll',
        '@media only screen and (max-width: 3500px)': {
            height: '250px',
        },
        '@media only screen and (min-width: 3501px)': {
            height: '500px',
        },
        '& td': {
            border: '1px solid #D7D7D7',
            padding: '5px',
            textAlign: 'left',
            '@media only screen and (max-width: 3500px)': {
                fontSize: '14pt',
            },
            '@media only screen and (min-width: 3501px)': {
                fontSize: '24pt',
            },
        },
        '& th': {
            border: '1px solid #D7D7D7',
            textAlign: 'left',
            '@media only screen and (max-width: 3500px)': {
                fontSize: '14pt',
                padding: '5px',
            },
            '@media only screen and (min-width: 3501px)': {
                fontSize: '24pt',
                padding: '10px 5px',
            },
        },
        '& .MuiPaper-root.MuiTableContainer-root': {
            width: '80%',
        },
        '& tbody.MuiTableBody-root tr.MuiTableRow-root:nth-child(odd)': {
            backgroundColor: ' #fff !important',
        },
    },
    myCheckBox: {
        '@media only screen and (max-width: 3500px)': {
            padding: 0,
        },
        '@media only screen and (min-width: 3501px)': {
            padding: 0,
            '& svg': {
                fontSize: '26pt',
                marginLeft: '-5px',
            }
        },
    },
    tickIcon: {
        margin: '0',
        textAlign: 'center',
    },
    checkedIcom: {
        color: '#006600',
        '@media only screen and (max-width: 3500px)': {
            fontSize: '15pt',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '24pt',
        },
    },
    crossIcom: {
        color: '#CC0000',
        '@media only screen and (max-width: 3500px)': {
            fontSize: '15pt',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '24pt',
        },
    },
    dataTDCheckBox: {
        textAlign: 'center !important',
        paddingLeft: '5px !important',
        paddingRight: '5px !important',
    },
    intervalOptionBlock: {
        width: '50%',
        float: 'left',
        margin: '0',
        '& label span': {
            '@media only screen and (max-width: 3500px)': {
                fontSize: '14pt',
            },
            '@media only screen and (min-width: 3501px)': {
                fontSize: '24pt',
                '& svg': {
                    fontSize: '26pt',
                    marginTop: '-5px',
                }
            },
        },
        '@media only screen and (min-width: 3501px)': {
            '& svg': {
                fontSize: '26pt',
                marginTop: '-5px',
            }
        },
    },
    headIcon: {
        color: '#333'
    },
    headIconBox: {
        textAlign: 'center !important',
    },
    consiInd: {
        float: 'left',
        background: '#24618E',
        marginLeft: '-5px',
        marginTop: '-14px',
        marginRight: '5px',
        position: 'relative',
        bottom: '-9px',
        '@media only screen and (max-width: 3500px)': {
            height: '36px',
            width: '7px',
        },
        '@media only screen and (min-width: 3501px)': {
            height: '54px',
            width: '10px',
        },
    },
    consiAlt: {
        width: '7px',
        float: 'left',
        background: '#00A75D',
        marginLeft: '-5px',
        marginTop: '-14px',
        marginRight: '5px',
        position: 'relative',
        bottom: '-9px',
        '@media only screen and (max-width: 3500px)': {
            height: '36px',
            width: '7px',
        },
        '@media only screen and (min-width: 3501px)': {
            height: '54px',
            width: '10px',
        },
    },
    consiGap: {
        width: '7px',
        float: 'left',
        background: '#fff',
        marginLeft: '-5px',
        marginTop: '-14px',
        marginRight: '5px',
        position: 'relative',
        bottom: '-9px',
        '@media only screen and (max-width: 3500px)': {
            height: '36px',
            width: '7px',
        },
        '@media only screen and (min-width: 3501px)': {
            height: '54px',
            width: '10px',
        },
    },
    dataBlock: {
        width: '100%',
    },
    exportBlock: {
        width: '100%',
        '& .MuiCheckbox-root': {
            padding: 0,
            paddingLeft: '10px',
            paddingRight: '3px',
        },
        '@media only screen and (min-width: 3501px)': {
            '& svg': {
                fontSize: '26pt',
                marginTop: '-5px',
            }
        },
    },
    stationCount: {
        margin: '10px 0px 5px 15px',
    },
    optionBock: {
        width: '100%',
        '& h4': {
            color: '#333',
            margin: '5px 0',
            '@media only screen and (max-width: 3500px)': {
                fontSize: '14pt',
            },
            '@media only screen and (min-width: 3501px)': {
                fontSize: '24pt',
            },
        },
        '& hr': {
            marginTop: '35px !important',
            marginBottom: '30px',
            width: '75%',
        }
    },
    dataCheck: {
        height: '5px',
        width: '5px',
        verticalAlign: 'middle',
    },
    outerCheck: {
        display: 'block',
        position: 'relative',
        paddingLeft: '0px',
        marginBottom: '0px',
        cursor: 'pointer',
        fontSize: '15px',
        '& input': {
            visibility: 'hidden',
            cursor: 'pointer',
        },
        '& .mark': {
            position: 'absolute',
            top: '2px',
            backgroundColor: '#fff',
            border: '2px solid #888',
            borderRadius: '2px',
            '@media only screen and (max-width: 3500px)': {
                height: '18px',
                width: '18px',
                left: '5px',
            },
            '@media only screen and (min-width: 3501px)': {
                height: '25px',
                width: '25px',
                left: '13px',
            },
        },
        '&:hover input ~ .mark': {
            backgroundColor: '#fff',
        },
        '& input:checked ~ .mark': {
            backgroundColor: 'blue',
            border: '1px solid blue',
        },
        '& .mark:after': {
            content: "",
            position: 'absolute',
            display: 'none',
        },
        '& input:checked ~ .mark:after': {
            display: 'block',
        },
        '& .mark:after': {
            top: '0px',
            border: 'solid #fff',
            transform: 'rotate(45deg)',
            borderWidth: '0 2px 2px 0',
            '@media only screen and (max-width: 3500px)': {
                left: '5px',
                width: '6px',
                height: '14px',
            },
            '@media only screen and (min-width: 3501px)': {
                left: '7px',
                width: '10px',
                height: '18px',
            },
        }
    },
    selectedError: {
        background: '#F2DEDE',
        border: '1px solid #CC0000',
        padding: '5px',
        color: '#333',
        borderRadius: '5px',
        marginBottom: '0px',
        marginTop: '10px',
        '& svg': {
            verticalAlign: 'top',
            marginRight: '5px',
            color: '#CC0000',
            '@media only screen and (max-width: 3500px)': {
                fontSize: '16pt',
            },
            '@media only screen and (min-width: 3501px)': {
                fontSize: '26pt',
            },
        }
    },
    dataloader: {
        width: '25px !important',
        height: '25px !important',
        color: '#fff !important',
        verticalAlign: 'middle',
    },
    loadingDiv: {
        width: '100%',
        background: 'rgba(0,0,0,.5)',
        position: 'absolute',
        height: '100%',
        zIndex: '999',
        marginTop: '-10px',
        marginLeft: '-10px',
        textAlign: 'center',
    },
    dataExportloader: {
        width: '70px !important',
        height: '70px !important',
        marginTop: '65px',
        '& svg': {
            color: '#fff',
        }
    },
    exportConsiCheckBox: {
        '@media only screen and (max-width: 3500px)': {
            marginLeft: '15px',
            fontSize: '14pt'
        },
        '@media only screen and (min-width: 3501px)': {
            marginLeft: '35px',
            fontSize: '24pt'
        },
    },
    tableIntersection: {
        '& .mark': {
            '@media only screen and (min-width: 3501px)': {
                left: '0 !important',
                top: '-5px',
            },
        }
    },
    tableMid: {

    },
    loaderDiv: {
        width: '100%',
        float: 'left',
        textAlign: 'center',
        '@media only screen and (max-width: 3500px)': {
            '& img': {
                height: '80px',
                width: '80px',
                marginTop: '70px'
            },
            '& p': {
                margin: '0px',
                marginTop: '25px',
                color: '#24618E',
                fontSize: '16pt'
            }
        },
        '@media only screen and (min-width: 3501px)': {
            '& img': {
                height: '150px',
                width: '150px',
                marginTop: '150px'
            },
            '& p': {
                margin: '0px',
                marginTop: '50px',
                color: '#24618E',
                fontSize: '26pt'
            }
        },
    }
}));
//End Css code ...

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

let stationTypeData;
let intervalOptionFirst = '15-minute intervals';
let intervalOptionSecond = '5-minute intervals';
let stationCount;
let StationIdGroup;

//Start ExportData component code ...
const ExportData = props => {
    const classes = useStyles();

    const [exportAsSingleFile, setExportAsSingleFile] = useState(false);

    const [interSectionData, setInterSectionData] = useState('block');
    const [midblockData, setMidblockData] = useState('inline-block');
    const [backPageBtn, setBackPageBtn] = useState('none');
    const [nextPageBtn, setNextPageBtn] = useState('inline-block');
    const [counter, setCounter] = useState(0);
    const [data, setData] = useState([]);
    const [exportFormatBlock, setExportFormatBlock] = useState('none');
    const [optionStatus, setOptionStatus] = useState('none');
    const [stationDataBlock, setStationDataBlock] = useState('inline-block');
    const [stationTypeName, setStationTypeName] = useState();
    const [getIntersectionDatesData, setIntersectionDatesData] = useState([]);
    const [getMidblockDatesData, setMidblockDatesData] = useState([]);
    const [getExportRequest, setExportRequest] = useState([]);
    const [intersectionInterval, setIntersectionInterval] = useState('15');
    const [midblockInterval, setMidblockInterval] = useState('60');
    const [intersectionStatus, setIntersectionStatus] = useState(0);
    const [midblockStatus, setMidblockStatus] = useState(0);
    const [consiCutiveStatus, setConsiCutiveStatus] = useState(0);
    const [optionSeparately, setOptionSeparately] = useState(true);
    const [optionCombined, setOptionCombined] = useState(true);
    const [loderStatus, setLoderStatus] = useState(0);
    const [noDataText, setNoDataText] = useState('');
    const [exportBtnStatus, setExportBtnStatus] = useState(true);
    const [idintityPool, setIdintityPool] = React.useState('');
    const [aswLogins, setAswLogins] = React.useState('');
    const [allCheckValue, setAllCheckValue] = React.useState(0);
    const [errorDisplay, setErrorDisplay] = React.useState('none');
    const [midVolValue, setMidVolValue] = React.useState(0);
    const [midClassValue, setMidClassValue] = React.useState(0);
    const [midSpeedValue, setMidSpeedValue] = React.useState(0);
    const [exportFailedError, setExportFailedError] = React.useState('');
    const [getConsiChecked, setConsiChecked] = React.useState(false);
    const [getCheckEvent, setCheckEvent] = React.useState(false);
    const [getErrorHtml, setErrorHtml] = React.useState(false);
    const [preConsiCheck, setPreConsiCheck] = React.useState([]);
    const [exportStatus, setExportStatus] = React.useState(false);
    const [getCheckHtml, setCheckHtml] = React.useState(0);
    const [stationId, setStationId] = useState(null);



    let consiIndicator = <div className={classes.consiInd}>&nbsp;</div>;
    let consiAltIndicator = <div className={classes.consiAlt}>&nbsp;</div>;
    let consiGapIndicator = <div className={classes.consiGap}>&nbsp;</div>;


    useEffect(
        () => {
            getAswToken();
            callExportData();
            stationCount = 1;
        }, []
    );

  //This method is used for get all Export Data .... Start
    const callExportData = () => {
        if (props.groupStations && props.groupStations.length > 0) {
            StationIdGroup = props.groupStations;
            stationTypeData = StationIdGroup[0].station_type == 1 ? "Midblock" + '  ' + StationIdGroup[0].client_Station_Id + ' - ' + StationIdGroup[0].Station_location : "Intersection" + '  ' + StationIdGroup[0].client_Station_Id + ' - ' + StationIdGroup[0].Station_location;
            setData(StationIdGroup);
            getExportData(StationIdGroup[0].station_id, StationIdGroup[0].station_type);
            setStationTypeName(StationIdGroup[0].station_type);
        }
        else {
            setStationTypeName('');
        }
    }
  //This method is used for get all Export Data .... End
   
    const nextPageData = () => {
        if (stationTypeName == 1) {
            sequenceIsConsecutive();
        }
        let count = counter;
        if (count < data.length) {
            count = count + 1;
            stationCount = stationCount + 1;
        }
        setCounter(count);
        pageData(count);
        setExportFailedError('');
        setCheckHtml(1);
    }
    const backPageData = () => {
        let count = counter;
        if (count > 0) {
            count = count - 1;
            stationCount = stationCount - 1;
        }
        setCounter(count);
        pageData(count);
        setExportFailedError('');
        setCheckHtml(1);
    }

    //This method is used for setting interval in midblock and intersection .... Start
    const pageData = (count) => {
        if (props.groupStations && props.groupStations.length > 0) {
            if (count >= 0 && count < data.length) {
                stationTypeData = StationIdGroup[count].station_type == 1 ? "Midblock" + '  ' + StationIdGroup[count].client_Station_Id + ' - ' + StationIdGroup[count].Station_location : "Intersection" + '  ' + StationIdGroup[count].client_Station_Id + ' - ' + StationIdGroup[count].Station_location;
                getExportData(StationIdGroup[count].station_id, StationIdGroup[count].station_type);
                setStationTypeName(StationIdGroup[count].station_type);
            }
            else {
                setStationTypeName('');
            }
        }
        if (count == 0) {
            setBackPageBtn('none');
            setNextPageBtn('inline-block');
            intervalOptionFirst = '15-minute intervals';
            intervalOptionSecond = '5-minute intervals';
            setExportFormatBlock('none');
            setStationDataBlock('inline-block');
            setOptionStatus('none');
            setErrorDisplay('none');
        } else if (count < data.length) {
            setBackPageBtn('inline-block');
            setNextPageBtn('inline-block');
            intervalOptionFirst = '60-minute intervals';
            intervalOptionSecond = '15-minute intervals';
            setExportFormatBlock('none');
            setStationDataBlock('inline-block');
            setOptionStatus('none');
            setErrorDisplay('none');
        } else if (count == data.length) {
            setBackPageBtn('inline-block');
            setNextPageBtn('inline-block');
            setExportFormatBlock('none');
            setStationDataBlock('none')
            setOptionStatus('inline-block');
            setErrorDisplay('inline-block');
        }
        else {
            setBackPageBtn('inline-block');
            setNextPageBtn('inline-block');
            setErrorDisplay('none');
        }
    }
    //This method is used for setting interval in midblock and intersection .... End


    //This method is used for Next Button .... Start
    const optionNextBtn = () => {
        setStationDataBlock('none')
        setExportFormatBlock('inline-block');
        setBackPageBtn('none');
        setNextPageBtn('none');
        setOptionStatus('none');
    }
    //This method is used for Next Button .... End


    //This method is used for Back Button .... Start
    const optionBackBtn = () => {
        setBackPageBtn('inline-block');
        setNextPageBtn('inline-block');
        setExportFormatBlock('none');
        setStationDataBlock('none')
        setOptionStatus('inline-block');
    }
    //This method is used for Back Button .... End


    //This method is used for get export data .... Start
    const getExportData = (station_id, stationType) => {
        if (stationType == 1) {
            midblockExportData(station_id);
        } else {
            intersectionExportData(station_id);
        }
    }
    //This method is used for get export data .... End



    //This method is use for API call to get midblock export data .... Start
    const midblockExportData = (station_id) => {
        setStationId(station_id);
        setMidblockDatesData([]);
        setLoderStatus(0);
        setNoDataText('');
        setConsiCutiveStatus(0);
        setErrorHtml(false);
        setCheckEvent(false);
        try {
            axios({
                method: 'post',
                timeout: 600000,
                data: {
                    stationId: station_id,
                },
                url: API_URL + API_PATH.exportdata,
                headers: {
                    'agencyid': sessionStorage.getItem('agency_id'),
                    'payload': Cookies.get('payload'),
                },
            })
                .then(async function (response) {

                    if (response && response.status == '200') {
                        let stationTypeData = response.data.data;
                        if (stationTypeData.length > 0) {
                            if (stationTypeData) {
                                setMidDataValue(stationTypeData).then(async result => {
                                    if (result && result.midarray) {
                                        if (result.midarray.length > 0) {
                                            setMidblockDatesData(result.midarray);
                                            setConsiCutiveStatus(result.con_status);
                                            checkReturnConsiCheckValue(result.station_id);
                                        }

                                        setAllCheckBox(result.midarray).then(async result => {
                                            if (result.length > 0) {
                                                setAllCheckValue(result);
                                            }
                                        }).catch(err => {
                                            console.log(err)
                                        })

                                        setNoDataText('');
                                        if (result.midarray.length > 0) {
                                            setMidblockStatus(1);
                                        }
                                    }
                                }).catch(err => {
                                    console.log(err)
                                })
                            }
                            else {
                                setMidblockDatesData([]);
                                setNoDataText('No data has been imported for this station');
                            }
                        }
                        else {
                            setNoDataText('No data has been imported for this station');
                        }

                    } else {
                        setNoDataText('No data has been imported for this station');
                    }
                    setLoderStatus(1);
                })
                .catch((err) => {
                    setLoderStatus(1);
                    setNoDataText('Something went wrong ...!');
                })
        } catch (error) {
            console.error(error);
            setLoderStatus(1);
            setNoDataText('Something went wrong ...!');
        }
        setConsiChecked(false);
    }
    //This method is use for API call to get midblock export data .... End

    //This method is use for consi checkbox selection .... Start
    const checkReturnConsiCheckValue = (station_id) => {
        let indexCheck = preConsiCheck.findIndex((ele, index) => ele.station_id === station_id);
        if (indexCheck === -1) {
            setPreConsiCheck([...preConsiCheck, { station_id: station_id, status: true }]);
        }
        else {
            let newArr = [...preConsiCheck];
            newArr[indexCheck] = {
                station_id: preConsiCheck[indexCheck].station_id,
                status: preConsiCheck[indexCheck].status
            };
            setPreConsiCheck(newArr);
            setConsiChecked(preConsiCheck[indexCheck].status);
        }
    }
    //This method is use for consi checkbox selection .... Start

    const setMidDataValue = (stationTypeData) => {
        let midDataArray = [];
        let consiStatus = 0;
        let con_color = '';
        let stationID;
        return new Promise((resolve, reject) => {
            for (let i = 0; i < stationTypeData.length; i++) {
                if (stationTypeData[i].consecutive_flag > 0 && stationTypeData[i].consecutive_status == true && (stationTypeData[i].consecutive_flag % 2 == 1)) {
                    con_color = 'green';
                    consiStatus = 1;
                }
                else if (stationTypeData[i].consecutive_flag > 0 && stationTypeData[i].consecutive_status == true && (stationTypeData[i].consecutive_flag % 2 == 0)) {
                    con_color = 'blue';
                    consiStatus = 1;
                }
                else {
                    con_color = 'white';
                }
                for (let j = 0; j < stationTypeData[i].dates.length; j++) {
                    let mainDate = stationTypeData[i].dates[j].date;
                    let totalDate = stationTypeData[i].dates[j].display_date;
                    midDataArray.push({ Station_id: stationTypeData[i].station_id, station_type: stationTypeData[i].station_type, mainDate: mainDate, date: totalDate, day: getDayFromDate(totalDate), volume: stationTypeData[i].dates[j].volume, class: stationTypeData[i].dates[j].class, speed: stationTypeData[i].dates[j].speed, con_color: con_color, consecutive_flag: stationTypeData[i].consecutive_flag, consecutive_status: stationTypeData[i].consecutive_status });
                }
                stationID = stationTypeData[i].station_id;
            }
            let obj = {
                midarray: midDataArray,
                con_status: consiStatus,
                station_id: stationID,
            }
            resolve(obj)
        })
    }


    // This function is used for unselect header checkboxes checkboxes
    const unselectHeaderCheckBoxes = (station_id) => {
        if (document.getElementById('all-volume-' + station_id) !== null) {
            document.getElementById('all-volume-' + station_id).checked = false;
        }
        if (document.getElementById('all-class-' + station_id) !== null) {
            document.getElementById('all-class-' + station_id).checked = false;
        }
        if (document.getElementById('all-speed-' + station_id) !== null) {
            document.getElementById('all-speed-' + station_id).checked = false;

        }
        if (document.getElementById('all-Checkbox-' + station_id) !== null) {
            document.getElementById('all-Checkbox-' + station_id).checked = false;
        }
    }
    // This function is used for unselect header checkboxes checkboxes

    // This function is used for unselect header checkboxes checkboxes
    const unselectRowAllCheckBoxse = () => {
        if (getMidblockDatesData.length > 0) {
            for (let i = 0; i < getMidblockDatesData.length; i++) {
                if (document.getElementById('all-' + getMidblockDatesData[i].Station_id + '-' + i) !== null) {
                    document.getElementById('all-' + getMidblockDatesData[i].Station_id + '-' + i).checked = false;
                }
            }
            if (document.getElementById('all-Checkbox-' + getMidblockDatesData[0].Station_id) !== null) {
                document.getElementById('all-Checkbox-' + getMidblockDatesData[0].Station_id).checked = false;
            }
        }
    }
    // This function is used for unselect header checkboxes checkboxes


    //Check Header Checkboxes method
    const checkHeaderCheckBoxes = (station_id) => {
        if (document.getElementById('all-volume-' + station_id) !== null) {
            setAllVolumeBox().then(async result => {
                setMidVolValue(result);
            }).catch(err => {
                console.log(err);
            });
        }
        if (document.getElementById('all-class-' + station_id) !== null) {
            setAllClassBox().then(async result => {
                setMidClassValue(result);
            }).catch(err => {
                console.log(err);
            });
        }
        if (document.getElementById('all-speed-' + station_id) !== null) {
            setAllSpeedBox().then(async result => {
                setMidSpeedValue(result);
            }).catch(err => {
                console.log(err);
            });
        }
        checkSelectedCheckBoxes();
    }
    //Check Header Checkboxes method

    const checkSelectedCheckValue = (checkedValue) => {
        let allVolumeValue = 1;
        return new Promise((resolve, reject) => {
            for (let i = 0; i < checkedValue.length; i++) {
                if (document.getElementById('all-' + checkedValue[i].Station_id + '-' + i)) {
                    if (!document.getElementById('all-' + checkedValue[i].Station_id + '-' + i).checked) {
                        allVolumeValue = 0;
                    }
                }
            }
            resolve(allVolumeValue);
        })
    }



    //This method is used for selected checkboxse show
    const checkSelectedCheckBoxes = () => {
        if (getExportRequest.length > 0) {
            for (let i = 0; i < getMidblockDatesData.length; i++) {
                let indexExprot = getExportRequest.findIndex((ele, index) => ele.Station_Id === getMidblockDatesData[i].Station_id && ele.date === getMidblockDatesData[i].mainDate);
                if (indexExprot !== -1) {
                    if (getExportRequest[indexExprot].volume) {
                        if (document.getElementById('volume-' + getMidblockDatesData[i].Station_id + '-' + i) !== null) {
                            document.getElementById('volume-' + getMidblockDatesData[i].Station_id + '-' + i).checked = true;
                        }
                    }
                    else {
                        if (document.getElementById('volume-' + getMidblockDatesData[i].Station_id + '-' + i) !== null) {
                            document.getElementById('volume-' + getMidblockDatesData[i].Station_id + '-' + i).checked = false;
                        }
                    }
                    if (getExportRequest[indexExprot].class) {
                        if (document.getElementById('class-' + getMidblockDatesData[i].Station_id + '-' + i) !== null) {
                            document.getElementById('class-' + getMidblockDatesData[i].Station_id + '-' + i).checked = true;
                        }
                    }
                    else {
                        if (document.getElementById('class-' + getMidblockDatesData[i].Station_id + '-' + i) !== null) {
                            document.getElementById('class-' + getMidblockDatesData[i].Station_id + '-' + i).checked = false;
                        }
                    }
                    if (getExportRequest[indexExprot].speed) {
                        if (document.getElementById('speed-' + getMidblockDatesData[i].Station_id + '-' + i) !== null) {
                            document.getElementById('speed-' + getMidblockDatesData[i].Station_id + '-' + i).checked = true;
                        }
                    }
                    else {
                        if (document.getElementById('speed-' + getMidblockDatesData[i].Station_id + '-' + i) !== null) {
                            document.getElementById('speed-' + getMidblockDatesData[i].Station_id + '-' + i).checked = false;
                        }
                    }

                    if (getExportRequest[indexExprot].volume && getExportRequest[indexExprot].class && getExportRequest[indexExprot].speed) {
                        if (document.getElementById('all-' + getMidblockDatesData[i].Station_id + '-' + i) !== null) {
                            document.getElementById('all-' + getMidblockDatesData[i].Station_id + '-' + i).checked = true;
                        }
                    }
                }
            }

            checkSelectedCheckValue(getMidblockDatesData).then(async result => {
                if (result === 1) {
                    if (document.getElementById('all-Checkbox-' + getMidblockDatesData[0].Station_id) !== null) {
                        document.getElementById('all-Checkbox-' + getMidblockDatesData[0].Station_id).checked = true;
                    }
                }
                else {
                    if (document.getElementById('all-Checkbox-' + getMidblockDatesData[0].Station_id) !== null) {
                        document.getElementById('all-Checkbox-' + getMidblockDatesData[0].Station_id).checked = false;
                    }
                }
            }).catch(err => {
                console.log(err);
            });
        }
    }
    //This method is used for selected checkboxse show


    const checkIntersectionBoxes = () => {
        if (getExportRequest.length > 0) {
            for (let i = 0; i < getIntersectionDatesData.length; i++) {
                let indexExprot = getExportRequest.findIndex((ele, index) => ele.Station_Id === getIntersectionDatesData[i].Station_id && ele.date === getIntersectionDatesData[i].mainDate);
                if (indexExprot !== -1) {
                    if (document.getElementById('interSection-' + getIntersectionDatesData[i].Station_id + '-' + i) !== null) {
                        document.getElementById('interSection-' + getIntersectionDatesData[i].Station_id + '-' + i).checked = true;
                    }
                }
            }
        }
    }

    //This method is used for header all checkbox event

    const setAllCheckBox = (midDataArray) => {
        let tempArray = [];
        let checkAllValue = 1;
        let checkVolValue = 0;
        let checkClassValue = 0;
        let checkSpeedValue = 0;
        return new Promise((resolve, reject) => {
            for (let i = 0; i < midDataArray.length; i++) {
                if (!midDataArray[i].volume || !midDataArray[i].class || !midDataArray[i].speed) {
                    checkAllValue = 0;
                }
                if (midDataArray[i].volume) {
                    checkVolValue = 1;
                }
                if (midDataArray[i].class) {
                    checkClassValue = 1;
                }
                if (midDataArray[i].speed) {
                    checkSpeedValue = 1;
                }
            }

            tempArray.push({ all: checkAllValue, volume: checkVolValue, class: checkClassValue, speed: checkSpeedValue });
            resolve(tempArray);
        })
    }



    //This method is used for intersection export data
    const intersectionExportData = (station_id) => {
        setStationId(station_id);
        setIntersectionDatesData([]);
        setLoderStatus(0);
        setNoDataText('');
        try {
            axios({
                method: 'post',
                timeout: 600000,
                data: {
                    stationId: station_id,
                },
                url: API_URL + API_PATH.exportdata,
                headers: {
                    'agencyid': sessionStorage.getItem('agency_id'),
                    'payload': Cookies.get('payload'),
                },
            })
                .then(async function (response) {
                    if (response && response.status == '200') {
                        let stationTypeData = response.data.data;
                        let interDataArray = [];
                        if (stationTypeData.dates) {
                            if (stationTypeData.dates.length > 0) {
                                for (let i = 0; i < stationTypeData.dates.length; i++) {
                                    let mainDate = stationTypeData.dates[i].date;
                                    let totalDate = stationTypeData.dates[i].display_date;
                                    interDataArray.push({ Station_id: stationTypeData.station_id, station_type: stationTypeData.station_type, mainDate: mainDate, date: totalDate, day: getDayFromDate(totalDate), turning: stationTypeData.dates[i].turning, pedestrian: stationTypeData.dates[i].pedestrian, bicycle: stationTypeData.dates[i].bicycle });
                                }
                                setIntersectionDatesData(interDataArray);
                                setNoDataText('');
                                if (interDataArray.length > 0) {
                                    setIntersectionStatus(1);
                                }
                            }
                            else {
                                setIntersectionDatesData([]);
                                setNoDataText('No data has been imported for this station');
                            }
                        } else {
                            setNoDataText('No data has been imported for this station');
                        }

                    } else {
                        setNoDataText('No data has been imported for this station');
                    }
                    setLoderStatus(1);
                }).catch((err) => {
                    setLoderStatus(1);
                    setNoDataText('Something went wrong ...!');
                })
        } catch (error) {
            console.error(error);
            setLoderStatus(1);
            setNoDataText('Something went wrong ...!');
        }
    }
    //This method is used for intersection export data

    //This function is call for file download
    const exportFile = () => {
        //setExportLoader(true);
        setExportStatus(true);
        setExportFailedError('');
        let interSectionIn = parseInt(intersectionInterval);
        let midblockIn = parseInt(midblockInterval);
        let setExportData = getExportRequest;
        //refress token
        getCSRFtoken()
        
        setZipDownloadData(setExportData, interSectionIn, midblockIn).then(async result => {
            if (result.length > 0) {
                try {
                    axios({
                        method: 'post',
                        timeout: 600000,
                        data: {
                            input: result
                        },
                        headers: {
                            'payload': Cookies.get('payload'),
                            'agencyid': sessionStorage.getItem('agency_id')
                        },
                        url: API_URL + API_PATH.export2csv,
                    })
                        .then(async function (response) {
                            if (response && response.status == '200') {
                                if (response.data && response.data.data) {
                                    let expoData = response.data.data;
                                    //
                                    downloadZipFile(expoData.file_name, expoData.bucket_name, expoData.folder_name);
                                }
                                else {
                                    //setExportLoader(false);
                                    setExportStatus(false);
                                    setExportFailedError('No Data available for export ... !');
                                }

                            } else {
                                //setExportLoader(false);
                                setExportStatus(false);
                                setExportFailedError('No Data available for export ... !');
                            }
                        }).catch(err => {
                            console.log(err)
                            //setExportLoader(false);
                            setExportStatus(false);
                            setExportFailedError('Something went wrong ...!');
                        })
                } catch (error) {
                    console.error(error);
                    //setExportLoader(false);
                    setExportStatus(false);
                    setExportFailedError('Export Failed try again ... !');
                }
            }
        }).catch(err => {
            console.log(err)
            //setExportLoader(false);
            setExportStatus(false);
            setExportFailedError('Something went wrong ...!');
        })
    }

    //This function is used for aws credential logins
    const getAswToken = () => {
        try {
            axios({
                method: 'get',
                url: API_URL + API_PATH.getAWSs3TokenAPI,
                headers: {
                    'agencyid': sessionStorage.getItem('agency_id'),
                    'payload': Cookies.get('payload'),
                },
            }).then(async function (response) {
                if (response.status && response.status == '200') {
                    let aswData = response.data;
                    setIdintityPool(aswData.data.IdentityPoolId);
                    setAswLogins(aswData.data.Logins);
                   
                } else {
                    console.log("");
                }
            })
        } catch (error) {
            console.error(error);
        }
    }
    //This function is used for aws credential logins

    //This function is used for download zip file
    const downloadZipFile = (file_name, bucket_name, folder_name) => {
        let OIDToken = Cookies.get('idToken');
       
        AWS.config.update(
            {
                region: 'us-west-2',
                credentials: new AWS.CognitoIdentityCredentials({
                    IdentityPoolId: idintityPool,
                    Logins: {
                        [aswLogins]: OIDToken
                    }
                })
            }
        );
        AWS.config.credentials.clearCachedId();
        let s3 = new AWS.S3();
        s3.getObject({ Bucket: bucket_name, Key: folder_name + '/' + file_name }, function (
            error, data) {
            if (error != null) {
                console.log(error)
                //setExportLoader(false);
                setExportStatus(false);
                setExportFailedError(error.message);
            } else {
                let blob = new Blob([data.Body], { type: data.ContentType });
                let link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = file_name;
                link.click();
                //setExportRequest([]);
                //setExportLoader(false);
                setExportStatus(false);
                closeExportPopUp();
            }
        });
    };
    //This function is used for download zip file

    const setZipDownloadData = (setExportData, interSectionIn, midblockIn) => {
        let tempArray = [];
        return new Promise((resolve, reject) => {
            for (let i = 0; i < setExportData.length; i++) {
                if (setExportData[i].station_type == 'Midblock') {
                    tempArray.push({
                        station_id: setExportData[i].Station_Id,
                        date: setExportData[i].date,
                        day: getDayFromDate(setExportData[i].date),
                        interval_time: midblockIn,
                        speed: setExportData[i].speed,
                        class: setExportData[i].class,
                        volume: setExportData[i].volume,
                        dir_opt_seprate: optionSeparately,
                        dir_opt_combined: optionCombined,
                        station_type: setExportData[i].station_type,
                        consecutive_flag: setExportData[i].consecutive_flag,
                        consecutive_status: setExportData[i].consecutive_status
                    });
                }
                else {
                    tempArray.push({
                        station_id: setExportData[i].Station_Id,
                        date: setExportData[i].date,
                        day: getDayFromDate(setExportData[i].date),
                        interval_time: interSectionIn,
                        speed: setExportData[i].speed,
                        class: setExportData[i].class,
                        volume: setExportData[i].volume,
                        dir_opt_seprate: false,
                        dir_opt_combined: false,
                        station_type: setExportData[i].station_type,
                        consecutive_flag: setExportData[i].consecutive_flag,
                        consecutive_status: setExportData[i].consecutive_status
                    });
                }
            }
            resolve(tempArray);
        })
    }
    //This function is call for file download

    //This function is used for intersection set Data
    const selectIntersectionData = async (e, Station_Id, station_type, data_date) => {
        let speed = false;
        let clas = false;
        let volume = false;
        let indexExprot = getExportRequest.findIndex((ele, index) => ele.Station_Id === Station_Id && ele.date === data_date);
        if (e.target.checked == true) {
            if (indexExprot === -1) {
                setExportRequest([...getExportRequest, { Station_Id: Station_Id, station_type: station_type, date: data_date, day: getDayFromDate(data_date), speed: speed, class: clas, volume: volume, consecutive_flag: 0, consecutive_status: false }]);
            } else {
                let newArr = [...getExportRequest];
                newArr[indexExprot] = {
                    Station_Id: getExportRequest[indexExprot].Station_Id,
                    station_type: getExportRequest[indexExprot].station_type,
                    date: getExportRequest[indexExprot].date,
                    day: getDayFromDate(getExportRequest[indexExprot].date),
                    speed: getExportRequest[indexExprot].speed,
                    class: getExportRequest[indexExprot].class,
                    volume: getExportRequest[indexExprot].volume,
                    consecutive_flag: 0,
                    consecutive_status: false
                };
                setExportRequest(newArr);
            }
        }
        else {
            if (indexExprot !== -1) {
                let newArr = getExportRequest;
                newArr.splice(indexExprot, 1);
                setExportRequest(newArr);
            }
        }
    }
    //This function is used for intersection set Data

    //This function is used for all midblock value
    const selectMidblockDataAll = async (e, Station_Id, station_type, data_date, consecutive_flag, consecutive_status, indexValue, volume, clas, speed) => {
        setCheckHtml(0);
        let indexExprot = getExportRequest.findIndex((ele, index) => ele.Station_Id === Station_Id && ele.date === data_date);
        if (e.target.checked == true) {
            if (indexExprot === -1) {
                setExportRequest([...getExportRequest, { Station_Id: Station_Id, station_type: station_type, date: data_date, day: getDayFromDate(data_date), speed: speed, class: clas, volume: volume, consecutive_flag: consecutive_flag, consecutive_status: consecutive_status }]);
            } else {
                let newArr = [...getExportRequest];
                newArr[indexExprot] = {
                    Station_Id: getExportRequest[indexExprot].Station_Id,
                    station_type: getExportRequest[indexExprot].station_type,
                    date: getExportRequest[indexExprot].date,
                    day: getDayFromDate(getExportRequest[indexExprot].date),
                    speed: speed,
                    class: clas,
                    volume: volume,
                    consecutive_flag: getExportRequest[indexExprot].consecutive_flag,
                    consecutive_status: getExportRequest[indexExprot].consecutive_status
                };
                setExportRequest(newArr);
            }
        }
        else {
            if (indexExprot !== -1) {
                let newArr = getExportRequest;
                newArr.splice(indexExprot, 1);
                setExportRequest(newArr);
            }
            unselectHeaderCheckBoxes(Station_Id);
        }
        selectUnselectMidblockCheckBoxes(Station_Id, indexValue, e.target.checked);


        setAllVolumeBox().then(async result => {
            setMidVolValue(result);
            mainCheckBoxValue(Station_Id);
        }).catch(err => {
            console.log(err)
        });


        setAllClassBox().then(async result => {
            setMidClassValue(result);
            mainCheckBoxValue(Station_Id);
        }).catch(err => {
            console.log(err)
        });


        setAllSpeedBox().then(async result => {
            setMidSpeedValue(result);
            mainCheckBoxValue(Station_Id);
        }).catch(err => {
            console.log(err)
        });
    }
    //This function is used for all midblock value   

    const selectUnselectMidblockCheckBoxes = (Station_Id, indexValue, checked) => {

        if (document.getElementById('volume-' + Station_Id + '-' + indexValue)) {
            document.getElementById('volume-' + Station_Id + '-' + indexValue).checked = checked;
        }
        if (document.getElementById('class-' + Station_Id + '-' + indexValue)) {
            document.getElementById('class-' + Station_Id + '-' + indexValue).checked = checked;
        }
        if (document.getElementById('speed-' + Station_Id + '-' + indexValue)) {
            document.getElementById('speed-' + Station_Id + '-' + indexValue).checked = checked;
        }
    }


    //This function set main top checkbox true
    const mainCheckBoxValue = (station_id) => {
        if (document.getElementById('all-volume-' + station_id) && document.getElementById('all-class-' + station_id) && document.getElementById('all-speed-' + station_id)) {

            if (document.getElementById('all-volume-' + station_id).checked && document.getElementById('all-class-' + station_id).checked && document.getElementById('all-speed-' + station_id).checked) {
                if (document.getElementById('all-Checkbox-' + station_id)) {
                    document.getElementById('all-Checkbox-' + station_id).checked = true;
                }
            }
            else {
                if (document.getElementById('all-Checkbox-' + station_id)) {
                    document.getElementById('all-Checkbox-' + station_id).checked = false;
                }

            }
        }
    }
    //This function set main top checkbox true

    //This function is used for midblock set Data
    const selectMidblockData = async (e, Station_Id, station_type, data_date, consecutive_flag, consecutive_status, indexValue) => {
        let indexExprot = getExportRequest.findIndex((ele, index) => ele.Station_Id === Station_Id && ele.date === data_date);
        let volCheck = document.getElementById('volume-' + Station_Id + '-' + indexValue);
        let classCheck = document.getElementById('class-' + Station_Id + '-' + indexValue);
        let speedCheck = document.getElementById('speed-' + Station_Id + '-' + indexValue);
        if (e.target.checked == true) {
            if (e.target.value == 'volume') {
                if (indexExprot === -1) {
                    setExportRequest([...getExportRequest, { Station_Id: Station_Id, station_type: station_type, date: data_date, day: getDayFromDate(data_date), speed: false, class: false, volume: true, consecutive_flag: consecutive_flag, consecutive_status: consecutive_status }]);
                } else {
                    let newArr = [...getExportRequest];
                    newArr[indexExprot] = {
                        Station_Id: getExportRequest[indexExprot].Station_Id,
                        station_type: getExportRequest[indexExprot].station_type,
                        date: getExportRequest[indexExprot].date,
                        day: getDayFromDate(getExportRequest[indexExprot].date),
                        speed: getExportRequest[indexExprot].speed,
                        class: getExportRequest[indexExprot].class,
                        volume: true,
                        consecutive_flag: getExportRequest[indexExprot].consecutive_flag,
                        consecutive_status: getExportRequest[indexExprot].consecutive_status
                    };
                    setExportRequest(newArr);
                }
            } else if (e.target.value == 'class') {
                if (indexExprot === -1) {
                    setExportRequest([...getExportRequest, { Station_Id: Station_Id, station_type: station_type, date: data_date, day: getDayFromDate(data_date), speed: false, class: true, volume: false, consecutive_flag: consecutive_flag, consecutive_status: consecutive_status }]);
                } else {
                    let newArr = [...getExportRequest];
                    newArr[indexExprot] = {
                        Station_Id: getExportRequest[indexExprot].Station_Id,
                        station_type: getExportRequest[indexExprot].station_type,
                        date: getExportRequest[indexExprot].date,
                        day: getDayFromDate(getExportRequest[indexExprot].date),
                        speed: getExportRequest[indexExprot].speed,
                        class: true,
                        volume: getExportRequest[indexExprot].volume,
                        consecutive_flag: getExportRequest[indexExprot].consecutive_flag,
                        consecutive_status: getExportRequest[indexExprot].consecutive_status
                    };
                    setExportRequest(newArr);
                }
            } else {
                if (indexExprot === -1) {
                    setExportRequest([...getExportRequest, { Station_Id: Station_Id, station_type: station_type, date: data_date, day: getDayFromDate(data_date), speed: true, class: false, volume: false, consecutive_flag: consecutive_flag, consecutive_status: consecutive_status }]);
                } else {
                    let newArr = [...getExportRequest];
                    newArr[indexExprot] = {
                        Station_Id: getExportRequest[indexExprot].Station_Id,
                        station_type: getExportRequest[indexExprot].station_type,
                        date: getExportRequest[indexExprot].date,
                        day: getDayFromDate(getExportRequest[indexExprot].date),
                        speed: true,
                        class: getExportRequest[indexExprot].class,
                        volume: getExportRequest[indexExprot].volume,
                        consecutive_flag: getExportRequest[indexExprot].consecutive_flag,
                        consecutive_status: getExportRequest[indexExprot].consecutive_status
                    };
                    setExportRequest(newArr);
                }
            }
            if (indexExprot !== -1) {
                if (volCheck && classCheck && speedCheck) {
                    if ((volCheck && volCheck.checked) && (classCheck && classCheck.checked) && (speedCheck && speedCheck.checked)) {
                        if (document.getElementById('all-' + Station_Id + '-' + indexValue)) {
                            document.getElementById('all-' + Station_Id + '-' + indexValue).checked = true;
                        }
                    }
                }
            }
            setAllVolumeBox().then(async result => {
                setMidVolValue(result);
            }).catch(err => {
                console.log(err)
            });


            setAllClassBox().then(async result => {
                setMidClassValue(result);
            }).catch(err => {
                console.log(err)
            });

            setAllSpeedBox().then(async result => {
                setMidSpeedValue(result);
            }).catch(err => {
                console.log(err)
            });

        }
        else {
            if (e.target.value == 'volume') {
                if (indexExprot === -1) {
                    setExportRequest([...getExportRequest, { Station_Id: Station_Id, station_type: station_type, date: data_date, day: getDayFromDate(data_date), speed: false, class: false, volume: false, consecutive_flag: consecutive_flag, consecutive_status: consecutive_status }]);
                } else {
                    let newArr = [...getExportRequest];
                    newArr[indexExprot] = {
                        Station_Id: getExportRequest[indexExprot].Station_Id,
                        station_type: getExportRequest[indexExprot].station_type,
                        date: getExportRequest[indexExprot].date,
                        day: getDayFromDate(getExportRequest[indexExprot].date),
                        speed: getExportRequest[indexExprot].speed,
                        class: getExportRequest[indexExprot].class,
                        volume: false,
                        consecutive_flag: getExportRequest[indexExprot].consecutive_flag,
                        consecutive_status: getExportRequest[indexExprot].consecutive_status
                    };

                    removeFalseArray(newArr).then(async result => {
                        setExportRequest(result);
                    }).catch(err => {
                        console.log(err);
                    });

                    if (document.getElementById('all-' + Station_Id + '-' + indexValue)) {
                        document.getElementById('all-' + Station_Id + '-' + indexValue).checked = false;
                    }
                }
            } else if (e.target.value == 'class') {
                if (indexExprot === -1) {
                    setExportRequest([...getExportRequest, { Station_Id: Station_Id, station_type: station_type, date: data_date, day: getDayFromDate(data_date), speed: false, class: false, volume: false, consecutive_flag: consecutive_flag, consecutive_status: consecutive_status }]);
                } else {
                    let newArr = [...getExportRequest];
                    newArr[indexExprot] = {
                        Station_Id: getExportRequest[indexExprot].Station_Id,
                        station_type: getExportRequest[indexExprot].station_type,
                        date: getExportRequest[indexExprot].date,
                        day: getDayFromDate(getExportRequest[indexExprot].date),
                        speed: getExportRequest[indexExprot].speed,
                        class: false,
                        volume: getExportRequest[indexExprot].volume,
                        consecutive_flag: getExportRequest[indexExprot].consecutive_flag,
                        consecutive_status: getExportRequest[indexExprot].consecutive_status
                    };

                    removeFalseArray(newArr).then(async result => {
                        setExportRequest(result);
                    }).catch(err => {
                        console.log(err);
                    });

                    if (document.getElementById('all-' + Station_Id + '-' + indexValue)) {
                        document.getElementById('all-' + Station_Id + '-' + indexValue).checked = false;
                    }
                }
            } else {
                if (indexExprot === -1) {
                    setExportRequest([...getExportRequest, { Station_Id: Station_Id, station_type: station_type, date: data_date, day: getDayFromDate(data_date), speed: false, class: false, volume: false, consecutive_flag: consecutive_flag, consecutive_status: consecutive_status }]);
                } else {
                    let newArr = [...getExportRequest];
                    newArr[indexExprot] = {
                        Station_Id: getExportRequest[indexExprot].Station_Id,
                        station_type: getExportRequest[indexExprot].station_type,
                        date: getExportRequest[indexExprot].date,
                        day: getDayFromDate(getExportRequest[indexExprot].date),
                        speed: false,
                        class: getExportRequest[indexExprot].class,
                        volume: getExportRequest[indexExprot].volume,
                        consecutive_flag: getExportRequest[indexExprot].consecutive_flag,
                        consecutive_status: getExportRequest[indexExprot].consecutive_status
                    };

                    removeFalseArray(newArr).then(async result => {
                        setExportRequest(result);
                    }).catch(err => {
                        console.log(err);
                    });

                    if (document.getElementById('all-' + Station_Id + '-' + indexValue)) {
                        document.getElementById('all-' + Station_Id + '-' + indexValue).checked = false;
                    }
                }
            }
            if (indexExprot !== -1) {
                if (volCheck && classCheck && speedCheck) {
                    if (volCheck.checked == false && classCheck.checked == false && speedCheck.checked == false) {
                        let newArr = getExportRequest;
                        newArr.splice(indexExprot, 1);
                        setExportRequest(newArr);
                        document.getElementById('all-' + Station_Id + '-' + indexValue).checked = false;
                    }
                }
            }

            setAllVolumeBox().then(async result => {
                setMidVolValue(result);
            }).catch(err => {
                console.log(err)
            });


            setAllClassBox().then(async result => {
                setMidClassValue(result);
            }).catch(err => {
                console.log(err)
            });


            setAllSpeedBox().then(async result => {
                setMidSpeedValue(result);
            }).catch(err => {
                console.log(err)
            });
        }
    }
    //This function is used for midblock set Data

    const setAllVolumeBox = () => {
        let allVolumeValue = 1;
        return new Promise((resolve, reject) => {
            for (let i = 0; i < getMidblockDatesData.length; i++) {
                if (document.getElementById('volume-' + getMidblockDatesData[i].Station_id + '-' + i)) {
                    if (!document.getElementById('volume-' + getMidblockDatesData[i].Station_id + '-' + i).checked) {
                        allVolumeValue = 0;
                    }
                }
            }
            resolve(allVolumeValue);
        })
    }

    const setAllClassBox = () => {
        let allClassValue = 1;
        return new Promise((resolve, reject) => {
            for (let i = 0; i < getMidblockDatesData.length; i++) {
                if (document.getElementById('class-' + getMidblockDatesData[i].Station_id + '-' + i)) {
                    if (!document.getElementById('class-' + getMidblockDatesData[i].Station_id + '-' + i).checked) {
                        allClassValue = 0;
                    }
                }
            }
            resolve(allClassValue);
        })
    }

    const setAllSpeedBox = () => {
        let allSpeedValue = 1;
        return new Promise((resolve, reject) => {
            for (let i = 0; i < getMidblockDatesData.length; i++) {
                if (document.getElementById('speed-' + getMidblockDatesData[i].Station_id + '-' + i)) {
                    if (!document.getElementById('speed-' + getMidblockDatesData[i].Station_id + '-' + i).checked) {
                        allSpeedValue = 0;
                    }
                }
            }
            resolve(allSpeedValue);
        })
    }

    //This function is used for all checkboxes
    const selectMidblockVolume = (e, Station_id, station_type, mainDate) => {
        setCheckHtml(0);
        let exportArray = getExportRequest;
        if (getMidblockDatesData.length > 0) {
            if (e.target.checked == true) {
                let tempArray = getExportRequest;
                for (let i = 0; i < getMidblockDatesData.length; i++) {
                    let indexExprot = getExportRequest.findIndex((ele, index) => ele.Station_Id === getMidblockDatesData[i].Station_id && ele.date === getMidblockDatesData[i].mainDate);
                    if (document.getElementById('volume-' + Station_id + '-' + i)) {
                        document.getElementById('volume-' + Station_id + '-' + i).checked = true;
                        if (indexExprot === -1) {
                            exportArray = [...exportArray, { Station_Id: getMidblockDatesData[i].Station_id, station_type: getMidblockDatesData[i].station_type, date: getMidblockDatesData[i].mainDate, day: getDayFromDate(getMidblockDatesData[i].mainDate), speed: false, class: false, volume: getMidblockDatesData[i].volume, consecutive_flag: getMidblockDatesData[i].consecutive_flag, consecutive_status: getMidblockDatesData[i].consecutive_status }];
                            setExportRequest(exportArray);
                        } else {
                            tempArray = [...tempArray];
                            tempArray[indexExprot] = {
                                Station_Id: getExportRequest[indexExprot].Station_Id,
                                station_type: getExportRequest[indexExprot].station_type,
                                date: getExportRequest[indexExprot].date,
                                day: getDayFromDate(getExportRequest[indexExprot].date),
                                speed: getExportRequest[indexExprot].speed,
                                class: getExportRequest[indexExprot].class,
                                volume: getMidblockDatesData[i].volume,
                                consecutive_flag: getExportRequest[indexExprot].consecutive_flag,
                                consecutive_status: getExportRequest[indexExprot].consecutive_status
                            };
                            setExportRequest(tempArray);
                        }
                    }
                }
                setAllVolumeBox().then(async result => {
                    setMidVolValue(result);
                    mainCheckBoxValue(Station_id);
                    allRowCheckBox(Station_id);
                }).catch(err => {
                    console.log(err)
                });


                setAllClassBox().then(async result => {
                    setMidClassValue(result);
                    mainCheckBoxValue(Station_id);
                    allRowCheckBox(Station_id);
                }).catch(err => {
                    console.log(err)
                });


                setAllSpeedBox().then(async result => {
                    setMidSpeedValue(result);
                    mainCheckBoxValue(Station_id);
                    allRowCheckBox(Station_id);
                }).catch(err => {
                    console.log(err)
                });
            }
            else {
                let tempArray = getExportRequest;
                for (let i = 0; i < getMidblockDatesData.length; i++) {
                    let indexExprot = getExportRequest.findIndex((ele, index) => ele.Station_Id === getMidblockDatesData[i].Station_id && ele.date === getMidblockDatesData[i].mainDate);
                    if (document.getElementById('volume-' + Station_id + '-' + i)) {
                        document.getElementById('volume-' + Station_id + '-' + i).checked = false;
                        if (indexExprot !== -1) {
                            tempArray = [...tempArray];
                            tempArray[indexExprot] = {
                                Station_Id: getExportRequest[indexExprot].Station_Id,
                                station_type: getExportRequest[indexExprot].station_type,
                                date: getExportRequest[indexExprot].date,
                                day: getDayFromDate(getExportRequest[indexExprot].date),
                                speed: getExportRequest[indexExprot].speed,
                                class: getExportRequest[indexExprot].class,
                                volume: false,
                                consecutive_flag: getExportRequest[indexExprot].consecutive_flag,
                                consecutive_status: getExportRequest[indexExprot].consecutive_status
                            };

                        }
                    }
                }
                setAllVolumeBox().then(async result => {
                    setMidVolValue(result);
                    mainCheckBoxValue(Station_id);
                    allRowCheckBox(Station_id);
                }).catch(err => {
                    console.log(err)
                });


                setAllClassBox().then(async result => {
                    setMidClassValue(result);
                    mainCheckBoxValue(Station_id);
                    allRowCheckBox(Station_id);
                }).catch(err => {
                    console.log(err)
                });


                setAllSpeedBox().then(async result => {
                    setMidSpeedValue(result);
                    mainCheckBoxValue(Station_id);
                    allRowCheckBox(Station_id);
                }).catch(err => {
                    console.log(err)
                });

                removeFalseArray(tempArray).then(async result => {
                    setExportRequest(result);
                }).catch(err => {
                    console.log(err);
                });
            }
        }
    }

    const selectMidblockClass = (e, Station_id, station_type, mainDate) => {
        setCheckHtml(0);
        let exportArray = getExportRequest;
        if (getMidblockDatesData.length > 0) {
            if (e.target.checked == true) {
                let tempArray = getExportRequest;
                for (let i = 0; i < getMidblockDatesData.length; i++) {
                    let indexExprot = getExportRequest.findIndex((ele, index) => ele.Station_Id === getMidblockDatesData[i].Station_id && ele.date === getMidblockDatesData[i].mainDate);
                    if (document.getElementById('class-' + Station_id + '-' + i)) {
                        document.getElementById('class-' + Station_id + '-' + i).checked = true;
                        if (indexExprot === -1) {
                            exportArray = [...exportArray, { Station_Id: getMidblockDatesData[i].Station_id, station_type: getMidblockDatesData[i].station_type, date: getMidblockDatesData[i].mainDate, day: getDayFromDate(getMidblockDatesData[i].mainDate), speed: false, class: getMidblockDatesData[i].class, volume: false, consecutive_flag: getMidblockDatesData[i].consecutive_flag, consecutive_status: getMidblockDatesData[i].consecutive_status }];
                            setExportRequest(exportArray);
                        } else {
                            tempArray = [...tempArray];
                            tempArray[indexExprot] = {
                                Station_Id: getExportRequest[indexExprot].Station_Id,
                                station_type: getExportRequest[indexExprot].station_type,
                                date: getExportRequest[indexExprot].date,
                                day: getDayFromDate(getExportRequest[indexExprot].date),
                                speed: getExportRequest[indexExprot].speed,
                                class: getMidblockDatesData[i].class,
                                volume: getExportRequest[indexExprot].volume,
                                consecutive_flag: getExportRequest[indexExprot].consecutive_flag,
                                consecutive_status: getExportRequest[indexExprot].consecutive_status
                            };
                            setExportRequest(tempArray);
                        }
                    }
                }
                setAllVolumeBox().then(async result => {
                    setMidVolValue(result);
                    mainCheckBoxValue(Station_id);
                    allRowCheckBox(Station_id);
                }).catch(err => {
                    console.log(err)
                });


                setAllClassBox().then(async result => {
                    setMidClassValue(result);
                    mainCheckBoxValue(Station_id);
                    allRowCheckBox(Station_id);
                }).catch(err => {
                    console.log(err)
                });


                setAllSpeedBox().then(async result => {
                    setMidSpeedValue(result);
                    mainCheckBoxValue(Station_id);
                    allRowCheckBox(Station_id);
                }).catch(err => {
                    console.log(err)
                });
            }
            else {
                let tempArray = getExportRequest;
                for (let i = 0; i < getMidblockDatesData.length; i++) {
                    let indexExprot = getExportRequest.findIndex((ele, index) => ele.Station_Id === getMidblockDatesData[i].Station_id && ele.date === getMidblockDatesData[i].mainDate);
                    if (document.getElementById('class-' + Station_id + '-' + i)) {
                        document.getElementById('class-' + Station_id + '-' + i).checked = false;
                        if (indexExprot !== -1) {
                            tempArray = [...tempArray];
                            tempArray[indexExprot] = {
                                Station_Id: getExportRequest[indexExprot].Station_Id,
                                station_type: getExportRequest[indexExprot].station_type,
                                date: getExportRequest[indexExprot].date,
                                day: getDayFromDate(getExportRequest[indexExprot].date),
                                speed: getExportRequest[indexExprot].speed,
                                class: false,
                                volume: getExportRequest[indexExprot].volume,
                                consecutive_flag: getExportRequest[indexExprot].consecutive_flag,
                                consecutive_status: getExportRequest[indexExprot].consecutive_status
                            };
                        }
                    }
                }
                setAllVolumeBox().then(async result => {
                    setMidVolValue(result);
                    mainCheckBoxValue(Station_id);
                    allRowCheckBox(Station_id);
                }).catch(err => {
                    console.log(err)
                });


                setAllClassBox().then(async result => {
                    setMidClassValue(result);
                    mainCheckBoxValue(Station_id);
                    allRowCheckBox(Station_id);
                }).catch(err => {
                    console.log(err)
                });


                setAllSpeedBox().then(async result => {
                    setMidSpeedValue(result);
                    mainCheckBoxValue(Station_id);
                    allRowCheckBox(Station_id);
                }).catch(err => {
                    console.log(err)
                });

                removeFalseArray(tempArray).then(async result => {
                    setExportRequest(result);
                }).catch(err => {
                    console.log(err);
                });
            }
        }
    }



    const selectMidblockSpeed = (e, Station_id, station_type, mainDate) => {
        setCheckHtml(0);
        let exportArray = getExportRequest;
        if (getMidblockDatesData.length > 0) {
            if (e.target.checked == true) {
                let tempArray = getExportRequest;
                for (let i = 0; i < getMidblockDatesData.length; i++) {
                    let indexExprot = getExportRequest.findIndex((ele, index) => ele.Station_Id === getMidblockDatesData[i].Station_id && ele.date === getMidblockDatesData[i].mainDate);
                    if (document.getElementById('speed-' + Station_id + '-' + i)) {
                        document.getElementById('speed-' + Station_id + '-' + i).checked = true;
                        if (indexExprot === -1) {
                            exportArray = [...exportArray, { Station_Id: getMidblockDatesData[i].Station_id, station_type: getMidblockDatesData[i].station_type, date: getMidblockDatesData[i].mainDate, day: getDayFromDate(getMidblockDatesData[i].mainDate), speed: getMidblockDatesData[i].speed, class: false, volume: false, consecutive_flag: getMidblockDatesData[i].consecutive_flag, consecutive_status: getMidblockDatesData[i].consecutive_status }];
                            setExportRequest(exportArray);
                        } else {
                            tempArray = [...tempArray];
                            tempArray[indexExprot] = {
                                Station_Id: getExportRequest[indexExprot].Station_Id,
                                station_type: getExportRequest[indexExprot].station_type,
                                date: getExportRequest[indexExprot].date,
                                day: getDayFromDate(getExportRequest[indexExprot].date),
                                speed: getMidblockDatesData[i].speed,
                                class: getExportRequest[indexExprot].class,
                                volume: getExportRequest[indexExprot].volume,
                                consecutive_flag: getExportRequest[indexExprot].consecutive_flag,
                                consecutive_status: getExportRequest[indexExprot].consecutive_status
                            };
                            setExportRequest(tempArray);
                        }
                    }
                }
                setAllVolumeBox().then(async result => {
                    setMidVolValue(result);
                    mainCheckBoxValue(Station_id);
                    allRowCheckBox(Station_id);
                }).catch(err => {
                    console.log(err)
                });


                setAllClassBox().then(async result => {
                    setMidClassValue(result);
                    mainCheckBoxValue(Station_id);
                    allRowCheckBox(Station_id);
                }).catch(err => {
                    console.log(err)
                });


                setAllSpeedBox().then(async result => {
                    setMidSpeedValue(result);
                    mainCheckBoxValue(Station_id);
                    allRowCheckBox(Station_id);
                }).catch(err => {
                    console.log(err)
                });
            }
            else {
                let tempArray = getExportRequest;
                for (let i = 0; i < getMidblockDatesData.length; i++) {
                    let indexExprot = getExportRequest.findIndex((ele, index) => ele.Station_Id === getMidblockDatesData[i].Station_id && ele.date === getMidblockDatesData[i].mainDate);
                    if (document.getElementById('speed-' + Station_id + '-' + i)) {
                        document.getElementById('speed-' + Station_id + '-' + i).checked = false;
                        if (indexExprot !== -1) {
                            tempArray = [...tempArray];
                            tempArray[indexExprot] = {
                                Station_Id: getExportRequest[indexExprot].Station_Id,
                                station_type: getExportRequest[indexExprot].station_type,
                                date: getExportRequest[indexExprot].date,
                                day: getDayFromDate(getExportRequest[indexExprot].date),
                                speed: false,
                                class: getExportRequest[indexExprot].class,
                                volume: getExportRequest[indexExprot].volume,
                                consecutive_flag: getExportRequest[indexExprot].consecutive_flag,
                                consecutive_status: getExportRequest[indexExprot].consecutive_status
                            };

                        }
                    }
                }
                setAllVolumeBox().then(async result => {
                    setMidVolValue(result);
                    mainCheckBoxValue(Station_id);
                    allRowCheckBox(Station_id);
                }).catch(err => {
                    console.log(err)
                });


                setAllClassBox().then(async result => {
                    setMidClassValue(result);
                    mainCheckBoxValue(Station_id);
                    allRowCheckBox(Station_id);
                }).catch(err => {
                    console.log(err)
                });


                setAllSpeedBox().then(async result => {
                    setMidSpeedValue(result);
                    mainCheckBoxValue(Station_id);
                    allRowCheckBox(Station_id);
                }).catch(err => {
                    console.log(err)
                });

                removeFalseArray(tempArray).then(async result => {
                    setExportRequest(result);
                }).catch(err => {
                    console.log(err);
                });
            }
        }
    }

    //This function is used for all checkboxes

    //This function used for rowAllCheckBox 
    const allRowCheckBox = (station_id) => {
        for (let i = 0; i < getMidblockDatesData.length; i++) {
            if (document.getElementById('volume-' + station_id + '-' + i) && document.getElementById('class-' + station_id + '-' + i) && document.getElementById('speed-' + station_id + '-' + i)) {
                if (document.getElementById('volume-' + station_id + '-' + i).checked && document.getElementById('class-' + station_id + '-' + i).checked && document.getElementById('speed-' + station_id + '-' + i).checked) {
                    if (document.getElementById('all-' + station_id + '-' + i)) {
                        document.getElementById('all-' + station_id + '-' + i).checked = true;
                    }
                }
                else {
                    if (document.getElementById('all-' + station_id + '-' + i)) {
                        document.getElementById('all-' + station_id + '-' + i).checked = false;
                    }
                }
            }
        }
    }

    //This method is used for remove all false value array
    const removeFalseArray = (tempArray) => {
        let exData = tempArray;
        return new Promise((resolve, reject) => {
            let tempArr = [];
            tempArr = exData.filter(val => { return val.volume || val.class || val.speed });
            resolve(tempArr);
        })
    }
    //This method is used for remove all false value array

    const selectAllTypeCheckBox = (e, station_id) => {
        setCheckHtml(0);
        let exportArray = getExportRequest;
        if (getMidblockDatesData.length > 0) {
            if (e.target.checked == true) {
                let tempArray = getExportRequest;
                for (let i = 0; i < getMidblockDatesData.length; i++) {
                    let indexExprot = getExportRequest.findIndex((ele, index) => ele.Station_Id === getMidblockDatesData[i].Station_id && ele.date === getMidblockDatesData[i].mainDate);
                    if (indexExprot === -1) {
                        exportArray = [...exportArray, { Station_Id: getMidblockDatesData[i].Station_id, station_type: getMidblockDatesData[i].station_type, date: getMidblockDatesData[i].mainDate, day: getDayFromDate(getMidblockDatesData[i].mainDate), speed: getMidblockDatesData[i].speed, class: getMidblockDatesData[i].class, volume: getMidblockDatesData[i].volume, consecutive_flag: getMidblockDatesData[i].consecutive_flag, consecutive_status: getMidblockDatesData[i].consecutive_status }];
                        setExportRequest(exportArray);
                    } else {
                        tempArray = [...tempArray];
                        tempArray[indexExprot] = {
                            Station_Id: getExportRequest[indexExprot].Station_Id,
                            station_type: getExportRequest[indexExprot].station_type,
                            date: getExportRequest[indexExprot].date,
                            day: getDayFromDate(getExportRequest[indexExprot].date),
                            speed: getMidblockDatesData[i].speed,
                            class: getMidblockDatesData[i].class,
                            volume: getMidblockDatesData[i].volume,
                            consecutive_flag: getExportRequest[indexExprot].consecutive_flag,
                            consecutive_status: getExportRequest[indexExprot].consecutive_status
                        };
                        setExportRequest(tempArray);
                    }

                    if (document.getElementById('volume-' + station_id + '-' + i)) {
                        document.getElementById('volume-' + station_id + '-' + i).checked = true;
                    }
                    if (document.getElementById('class-' + station_id + '-' + i)) {
                        document.getElementById('class-' + station_id + '-' + i).checked = true;
                    }
                    if (document.getElementById('speed-' + station_id + '-' + i)) {
                        document.getElementById('speed-' + station_id + '-' + i).checked = true;
                    }
                    if (document.getElementById('all-' + station_id + '-' + i)) {
                        document.getElementById('all-' + station_id + '-' + i).checked = true;
                    }
                    if (document.getElementById('all-volume-' + station_id)) {
                        document.getElementById('all-volume-' + station_id).checked = true;
                        setMidVolValue(1);
                    }
                    if (document.getElementById('all-class-' + station_id)) {
                        document.getElementById('all-class-' + station_id).checked = true;
                        setMidClassValue(1);
                    }
                    if (document.getElementById('all-speed-' + station_id)) {
                        document.getElementById('all-speed-' + station_id).checked = true;
                        setMidSpeedValue(1)
                    }
                }
            }
            else {
                let tempArray = getExportRequest;
                for (let i = 0; i < getMidblockDatesData.length; i++) {
                    let indexExprot = getExportRequest.findIndex((ele, index) => ele.Station_Id === getMidblockDatesData[i].Station_id && ele.date === getMidblockDatesData[i].mainDate);
                    if (document.getElementById('volume-' + station_id + '-' + i)) {
                        document.getElementById('volume-' + station_id + '-' + i).checked = false;
                    }
                    if (document.getElementById('class-' + station_id + '-' + i)) {
                        document.getElementById('class-' + station_id + '-' + i).checked = false;
                    }
                    if (document.getElementById('speed-' + station_id + '-' + i)) {
                        document.getElementById('speed-' + station_id + '-' + i).checked = false;
                    }
                    if (document.getElementById('all-' + station_id + '-' + i)) {
                        document.getElementById('all-' + station_id + '-' + i).checked = false;
                    }
                    if (document.getElementById('all-volume-' + station_id)) {
                        document.getElementById('all-volume-' + station_id).checked = false;
                        setMidVolValue(0);
                    }
                    if (document.getElementById('all-class-' + station_id)) {
                        document.getElementById('all-class-' + station_id).checked = false;
                        setMidClassValue(0);
                    }
                    if (document.getElementById('all-speed-' + station_id)) {
                        document.getElementById('all-speed-' + station_id).checked = false;
                        setMidSpeedValue(0)
                    }
                    if (indexExprot !== -1) {
                        tempArray = [...tempArray];
                        tempArray[indexExprot] = {
                            Station_Id: getExportRequest[indexExprot].Station_Id,
                            station_type: getExportRequest[indexExprot].station_type,
                            date: getExportRequest[indexExprot].date,
                            day: getDayFromDate(getExportRequest[indexExprot].date),
                            speed: false,
                            class: false,
                            volume: false,
                            consecutive_flag: getExportRequest[indexExprot].consecutive_flag,
                            consecutive_status: getExportRequest[indexExprot].consecutive_status
                        };
                    }
                }
                removeFalseArray(tempArray).then(async result => {
                    setExportRequest(result);
                }).catch(err => {
                    console.log(err);
                });
            }
        }
    }

    //Interval option value change 
    const intervalHandleChange = (event) => {
        setIntersectionInterval(event.target.value);
    }
    //Interval option value change 

    //Midblock option value change 
    const midblockHandleChange = (event) => {
        setMidblockInterval(event.target.value);
    }
    //Midblock option value change 

    //This function is called for file export option
    const checkOptionSeparately = (e) => {
        setOptionSeparately(e.target.checked);
    }
    const checkOptionCombined = (e) => {
        setOptionCombined(e.target.checked);
    }
    //This function is called for file export option

    //This function is used for export btn 
    const exportToCsv = (e) => {
        if (e.target.checked == true) {
            setExportBtnStatus(true);
        }
        else {
            setExportBtnStatus(false);
        }
    }
    //This function is used for export btn   

    //This code is uded for close pop up
    const closeExportPopUp = () => {
        props.checkExportValue();
        setExportRequest([]);
    }
    //This code is uded for close pop up   

    //This function is used to Consecutive Dates selection
    const selectConsecutiveDates = (e) => {
        if (getExportRequest.length > 0) {
            setExportAsSingleFile(e.target.checked);
            if (e.target.checked) {
                let tempArray = getExportRequest;
                for (let i = 0; i < getMidblockDatesData.length; i++) {
                    let indexExprot = getExportRequest.findIndex((ele, index) => ele.Station_Id === getMidblockDatesData[i].Station_id && ele.date === getMidblockDatesData[i].mainDate);
                    if (indexExprot !== -1) {
                        tempArray = [...tempArray];
                        tempArray[indexExprot] = {
                            Station_Id: getExportRequest[indexExprot].Station_Id,
                            station_type: getExportRequest[indexExprot].station_type,
                            date: getExportRequest[indexExprot].date,
                            day: getDayFromDate(getExportRequest[indexExprot].date),
                            speed: getExportRequest[indexExprot].speed,
                            class: getExportRequest[indexExprot].class,
                            volume: getExportRequest[indexExprot].volume,
                            consecutive_flag: getMidblockDatesData[i].consecutive_flag,
                            consecutive_status: getMidblockDatesData[i].consecutive_status
                        };
                    }
                }
                setExportRequest(tempArray);
            }
            else {
                let tempArray = getExportRequest;
                for (let i = 0; i < getMidblockDatesData.length; i++) {
                    let indexExprot = getExportRequest.findIndex((ele, index) => ele.Station_Id === getMidblockDatesData[i].Station_id && ele.date === getMidblockDatesData[i].mainDate);
                    if (indexExprot !== -1) {
                        tempArray = [...tempArray];
                        tempArray[indexExprot] = {
                            Station_Id: getExportRequest[indexExprot].Station_Id,
                            station_type: getExportRequest[indexExprot].station_type,
                            date: getExportRequest[indexExprot].date,
                            day: getDayFromDate(getExportRequest[indexExprot].date),
                            speed: getExportRequest[indexExprot].speed,
                            class: getExportRequest[indexExprot].class,
                            volume: getExportRequest[indexExprot].volume,
                            consecutive_flag: 0,
                            consecutive_status: false
                        };
                    }
                }
                setExportRequest(tempArray);
            }
            setConsiChecked(e.target.checked);
        }
        checkConsiDateEvent(getMidblockDatesData[0].Station_id, e.target.checked);
    }
    //This function is used to Consecutive Dates selection

    //This function is used for checkConsiDateEvent
    const checkConsiDateEvent = (station_id, e) => {
        setErrorHtml(false);
        let indexExprot = getExportRequest.findIndex((ele, index) => ele.Station_Id === station_id);
        let indexCheck = preConsiCheck.findIndex((ele, index) => ele.station_id === station_id);
        // if (indexExprot === -1) {
        //     // setErrorHtml(true);
        //     setConsiChecked(true);
        // }
        // else {
        setErrorHtml(false);
        setConsiChecked(e);
        if (indexCheck === -1) {
            setPreConsiCheck([...preConsiCheck, { station_id: station_id, status: e }]);
        }
        else {
            let newArr = [...preConsiCheck];
            newArr[indexCheck] = {
                station_id: preConsiCheck[indexCheck].station_id,
                status: e
            };
            setPreConsiCheck(newArr);
        }
        // }
    }
    //This function is used for checkConsiDateEvent

    const getDayFromDate = (date) => {
        return parseInt(date.split('-')[2]);
    }

    //This is to check consecutive dates selected for export
    const sequenceIsConsecutive = () => {
        let currentStation = getExportRequest.filter(val => val.Station_Id === stationId); // get data of selected station
        let newArr = [];
        if (getConsiChecked) {
            const group = currentStation.reduce((acc, item) => { //group by consecutive_flag of selected dates
                if (stationId === item.Station_Id) {
                    if (!acc[item.consecutive_flag]) {
                        acc[item.consecutive_flag] = [];
                    }

                    acc[item.consecutive_flag].push(item);
                    return acc;
                }
            }, []);
            
            let filteredArr = [];
            if (group && group.length > 0) {
                for (let i = 0; i < group.length; i++) {
                    if (group[i] && group[i].length > 1) {
                        let consec_count = 0;
                        group[i].sort(function(a,b){
                            // Turn your strings into dates, and then subtract them
                            // to get a value that is either negative, positive, or zero.
                            return new Date(b.date) - new Date(a.date);
                        });
                        /*group[i].forEach(function(rec, ind) {
                            // iterating all dates in each group
                            let cTimestamp = new Date(rec.date).getTime();
                            if(group[i][ind+1]) {
                                let nextTimestamp = new Date(group[i][ind+1].date).getTime();
                                // getting the difference for the next date
                                var dif = cTimestamp - nextTimestamp;
                                dif = dif/1000/60/60/24;
                                if (dif === 1 || dif === -1) {
                                    // it means there is one day of difference
                                    consec_count++;
                                } 
                            }
                        });
                        if(consec_count === group[i].length - 1) {
                            // all days are consecutive
                            group[i].map((val) => { val.consecutive_flag !== 0 ? val.consecutive_status = true :  val.consecutive_status = false});
                        } else  {*/
                            // alternative way of consecutive days
                            let volitems = [];
                            let classitems = [];
                            let speeditems = [];
                            group[i].forEach(function(rec) {
                                if(rec.speed)
                                    speeditems.push(rec);
                                if(rec.volume)
                                    volitems.push(rec);
                                if(rec.class)
                                    classitems.push(rec);
                            });

                            // consecutive days by type
                            let speed_consec_count = 0;
                            speeditems.forEach(function(sp, ind) {
                                let cTimestamp = new Date(sp.date).getTime();
                                if(speeditems[ind+1]) {
                                    let nextTimestamp = new Date(speeditems[ind+1].date).getTime();
                                    // getting the difference for the next date
                                    var dif = cTimestamp - nextTimestamp;
                                    dif = dif/1000/60/60/24;
                                    if (dif === 1 || dif === -1) {
                                        // it means there is one day of difference
                                        speed_consec_count++;
                                    } 
                                }
                            })
                            let vol_consec_count = 0;
                            volitems.forEach(function(sp, ind) {
                                let cTimestamp = new Date(sp.date).getTime();
                                if(volitems[ind+1]) {
                                    let nextTimestamp = new Date(volitems[ind+1].date).getTime();
                                    // getting the difference for the next date
                                    var dif = cTimestamp - nextTimestamp;
                                    dif = dif/1000/60/60/24;
                                    if (dif === 1 || dif === -1) {
                                        // it means there is one day of difference
                                        vol_consec_count++;
                                    } 
                                }
                            })
                            let class_consec_count = 0;
                            classitems.forEach(function(sp, ind) {
                                let cTimestamp = new Date(sp.date).getTime();
                                if(classitems[ind+1]) {
                                    let nextTimestamp = new Date(classitems[ind+1].date).getTime();
                                    // getting the difference for the next date
                                    var dif = cTimestamp - nextTimestamp;
                                    dif = dif/1000/60/60/24;
                                    if (dif === 1 || dif === -1) {
                                        // it means there is one day of difference
                                        class_consec_count++;
                                    } 
                                }
                            })

                            if(vol_consec_count === volitems.length-1) {
                                group[i].forEach(function(gitem, ind) {
                                    if(gitem.volume) {
                                        if(gitem.consecutive_flag !== 0)
                                            group[i][ind]['consecutive_status'] = true;
                                        else {
                                            // not consecutive
                                            group[i][ind]['consecutive_flag'] = 0;
                                            group[i][ind]['consecutive_status'] = false;
                                        }
                                    }
                                })
                            } else if(volitems.length > 0) {
                                group[i].forEach(function(gitem, ind) {
                                    if(gitem.volume){
                                        // not consecutive
                                        group[i][ind]['consecutive_flag'] = 0;
                                        group[i][ind]['consecutive_status'] = false;
                                    }
                                })
                            }

                            if(speed_consec_count === speeditems.length-1) {
                                group[i].forEach(function(gitem, ind) {
                                    if(gitem.speed) {
                                        if(gitem.consecutive_flag !== 0)
                                            group[i][ind]['consecutive_status'] = true;
                                        else {
                                            // not consecutive
                                            group[i][ind]['consecutive_flag'] = 0;
                                            group[i][ind]['consecutive_status'] = false;
                                        }
                                    }
                                })
                            } else if(speeditems.length > 0) {
                                group[i].forEach(function(gitem, ind) {
                                    if(gitem.speed) {
                                        // not consecutive
                                        group[i][ind]['consecutive_flag'] = 0;
                                        group[i][ind]['consecutive_status'] = false;
                                    }
                                })
                            }

                            if(class_consec_count === classitems.length-1) {
                                group[i].forEach(function(gitem, ind) {
                                    if(gitem.class) {
                                        if(gitem.consecutive_flag !== 0)
                                            group[i][ind]['consecutive_status'] = true;
                                        else {
                                            // not consecutive
                                            group[i][ind]['consecutive_flag'] = 0;
                                            group[i][ind]['consecutive_status'] = false;
                                        }
                                    }
                                })
                            } else if(classitems.length > 0) {
                                group[i].forEach(function(gitem, ind) {
                                    if(gitem.class){
                                        // not consecutive
                                        group[i][ind]['consecutive_flag'] = 0;
                                        group[i][ind]['consecutive_status'] = false;
                                    }
                                })
                            }

                            //     // days are not consecutive
                            //     group[i].map((val) => { val.consecutive_status = false; val.consecutive_flag = 0 });
                        /*}*/
                        filteredArr.push(...group[i]);
                    } else if(group[i] && group[i].length == 1) {
                        group[i].map((val) => { val.consecutive_status = false; val.consecutive_flag = 0 });
                        filteredArr.push(...group[i]);
                    }
                }
            }
            newArr = getExportRequest.filter((item) => item.Station_Id !== filteredArr[0].station_id);
            setExportRequest(newArr);
        }
        else {
            newArr = getExportRequest.map((val) => val.Station_Id == stationId ? ({ ...val, consecutive_status: false, consecutive_flag: 0 }) : val);
            setExportRequest(newArr);
        }
    }
    ///
    const getCSRFtoken = () => { // API call to get CSRF token 
    try {
        axios({
          method: 'get',
          url: API_URL + API_PATH.getcsrftoken,
        })
          .then(async function (response) {
            if (response && response.data && response.data.csrfToken) {
              axios.defaults.headers.common['X-CSRF-TOKEN'] = response.data.csrfToken; //set CSRF token in request headers
              getAccessToken(response.data.csrfToken);
            } else {
              clearCookie('email');
              clearCookie('payload');
              clearCookie('idToken');
              clearCookie('atexpiry');
              clearCookie('alLogIn');
              window.location.href = '/';
            }
          })
          .catch(function (error) {
            clearCookie('email');
            clearCookie('payload');
            clearCookie('idToken');
            clearCookie('atexpiry');
            clearCookie('alLogIn');
            window.location.href = '/';
          })
      } catch (error) {
        clearCookie('email');
        clearCookie('payload');
        clearCookie('idToken');
        clearCookie('atexpiry');
        clearCookie('alLogIn');
        window.location.href = '/';
      }
    }
  
    const getAccessToken = (csrfToken) => { //API call to request access token
      try {
        axios({
          method: 'post',
          data: {
            email: Cookies.get('email'),
            rememberMe: Cookies.get('alLogIn') == 'false' ? false : true
          },
          url: API_URL + API_PATH.getRefreshToken,
          'X-CSRF-TOKEN': csrfToken
        })
          .then(async function (response) {
            if (response.status && response.status == '200') {
              console.log("refresh tocken ok1 ")
              if (response.data.payload) {
                console.log("refresh tocken ok2 ")
  
                setCookie('idToken', response.data.IdToken);
                setCookie('payload', response.data.payload);
                setCookie('atexpiry', response.data.access_token_expiry);
              } else {
                console.log("refresh tocken ok3 ")
                clearCookie('email');
                clearCookie('payload');
                clearCookie('idToken');
                clearCookie('atexpiry');
                clearCookie('alLogIn');
                window.location.href = '/';
              }
            } else {
              console.log("refresh tocken ok4 ")
              clearCookie('email');
              clearCookie('payload');
              clearCookie('idToken');
              clearCookie('atexpiry');
              clearCookie('alLogIn');
              window.location.href = '/';
            }
          })
          .catch(function (error) {
            clearCookie('email');
            clearCookie('payload');
            clearCookie('idToken');
            clearCookie('atexpiry');
            clearCookie('alLogIn');
            window.location.href = '/';
          })
      } catch (error) {
        clearCookie('email');
        clearCookie('payload');
        clearCookie('idToken');
        clearCookie('atexpiry');
        clearCookie('alLogIn');
        window.location.href = '/';
      }
    }
  

    return (
        <React.Fragment>
            <div className={classes.ExternalMainBlock} style={{ height: window.screen.width >= 1550 && window.screen.width <= 1750 ? '93.1%' : window.screen.width >= 1751 && window.screen.width <= 3500? '94.5%' : window.screen.width >= 3501? '97.5%' :'92.4%' }}>
                <div className={classes.mainBlock} style={{ pointerEvents: 'visible', top: window.screen.width >= 1550 && window.screen.width <= 1750 ? '60px' : window.screen.width >= 1751 && window.screen.width <= 3500 ? '60px' : window.screen.width >= 3501 ? '150px' : '35px' }}>
                    {exportStatus ? <div className={classes.loadingDiv}>
                        <CircularProgress className={classes.dataExportloader} />
                        {/* <p style={{ margin: '0px', marginTop: '10px', color: '#fff', fontSize: '16pt' }}>Data is exporting , please wait .... !</p> */}
                    </div> : null}
                    <h3>Export Station Data</h3>
                    <p className={classes.closeIcom} title='Close' onClick={closeExportPopUp}>
                        <FontAwesomeIcon icon={faTimes} className={classes.btnIcon} title='Close' />
                    </p>
                    <hr />
                    <div className={classes.dataBlock} style={{ display: stationDataBlock }}>
                        {data.length > 1 ? <p className={classes.stationCount}>Station {stationCount} of {data.length}</p> : null}
                        <fieldset className={classes.fieldsetname}>
                            <legend>Station</legend>
                            <p className={classes.stationIdDataPara} style={{ marginTop: '-10px' }}>{stationTypeData}</p>
                        </fieldset>
                        <fieldset className={classes.fieldsetname}>
                            <legend>Dates</legend>
                            <div className={classes.dataTableblock}>
                                {/* This html code for intersection data */}
                                {stationTypeName == 2 ?
                                    <div className={classes.tableScreen} style={{ display: interSectionData }}>
                                        {/* <CircularProgress className={classes.dataloader}/> */}
                                        {loderStatus == 0 ?
                                            <div className={classes.loaderDiv}>
                                                <img src={require('../../assets/images/loaderImg.gif')} />
                                                <p>Data is loading, please wait .... !</p>
                                            </div>
                                            : null}
                                        <TableContainer component={Paper}>
                                            {getIntersectionDatesData.length > 0 ?
                                                <Table className={classes.tableIntersection} aria-label="customized table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell align="right" className={classes.tableHead}></TableCell>
                                                            <TableCell align="right" className={classes.tableHead}>Date</TableCell>
                                                            <TableCell align="right" className={classes.tableHead, classes.headIconBox} title='Turning Movement'>
                                                                <FontAwesomeIcon icon={faReply} className={classes.headIcon} title='Turning Movement' style={{ cursor: 'pointer' }} />
                                                            </TableCell>
                                                            <TableCell align="right" className={classes.tableHead, classes.headIconBox} title='Pedestrian'>
                                                                <FontAwesomeIcon icon={faWalking} className={classes.headIcon} title='Pedestrian' style={{ cursor: 'pointer' }} />
                                                            </TableCell>
                                                            <TableCell align="right" className={classes.tableHead, classes.headIconBox} title='Bicycle'>
                                                                <FontAwesomeIcon icon={faBiking} className={classes.headIcon} title='Bicycle' style={{ cursor: 'pointer' }} />
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {getIntersectionDatesData.map((getDates, index) => (
                                                            <StyledTableRow key={index}>
                                                                <TableCell align="right" className={classes.dataTDCheckBox} style={{ width: '40px' }}>
                                                                    {/* <Checkbox
                                                                        color="primary" className={classes.myCheckBox}
                                                                        inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                                        onChange={(e) => selectIntersectionData(e, getDates.Station_id, getDates.station_type, getDates.mainDate)}
                                                                    /> */}
                                                                    <label className={classes.outerCheck}>
                                                                        <input type='checkbox' name='interSection' value='interSection' className={classes.dataCheck} id={'interSection-' + getDates.Station_id + '-' + index} onChange={(e) => selectIntersectionData(e, getDates.Station_id, getDates.station_type, getDates.mainDate)} />
                                                                        <span className="mark"></span>
                                                                    </label>
                                                                </TableCell>
                                                                <TableCell align="right" className={classes.dataTD}>{getDates.date}</TableCell>
                                                                <TableCell align="right" className={classes.dataTD}>
                                                                    {getDates.turning == true ?
                                                                        <p className={classes.tickIcon}>
                                                                            <FontAwesomeIcon icon={faCheck} className={classes.checkedIcom} />
                                                                        </p>
                                                                        : <p className={classes.tickIcon}>
                                                                            <FontAwesomeIcon icon={faTimes} className={classes.crossIcom} />
                                                                        </p>}
                                                                </TableCell>
                                                                <TableCell align="right" className={classes.dataTD}>
                                                                    {getDates.pedestrian == true ?
                                                                        <p className={classes.tickIcon}>
                                                                            <FontAwesomeIcon icon={faCheck} className={classes.checkedIcom} />
                                                                        </p>
                                                                        : <p className={classes.tickIcon}>
                                                                            <FontAwesomeIcon icon={faTimes} className={classes.crossIcom} />
                                                                        </p>}
                                                                </TableCell>
                                                                <TableCell align="right" className={classes.dataTD}>
                                                                    {getDates.bicycle == true ?
                                                                        <p className={classes.tickIcon}>
                                                                            <FontAwesomeIcon icon={faCheck} className={classes.checkedIcom} />
                                                                        </p>
                                                                        : <p className={classes.tickIcon}>
                                                                            <FontAwesomeIcon icon={faTimes} className={classes.crossIcom} />
                                                                        </p>}
                                                                    {index === getIntersectionDatesData.length - 1 ? checkIntersectionBoxes() : null}
                                                                </TableCell>
                                                            </StyledTableRow>
                                                        ))
                                                        }
                                                    </TableBody>
                                                </Table>
                                                : <p>{noDataText}</p>}
                                        </TableContainer>
                                    </div>
                                    : stationTypeName == 1 ?
                                        <div className={classes.tableScreen} style={{ display: midblockData }}>
                                            {/* <CircularProgress className={classes.dataloader}/> */}
                                            {loderStatus == 0 ?
                                                <div className={classes.loaderDiv}>
                                                    <img src={require('../../assets/images/loaderImg.gif')} />
                                                    <p>Data is loading, please wait .... !</p>
                                                </div>
                                                : null}
                                            <TableContainer component={Paper}>
                                                {getMidblockDatesData.length > 0 ?
                                                    <Table className={classes.tableMid} aria-label="customized table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell align="right" className={classes.tableHead} style={{ textAlign: 'right' }}>Select all of this type</TableCell>
                                                                <TableCell align="right" className={classes.dataTDCheckBox}>
                                                                    {/* <input type='checkbox' name='all-all' value='all-all' className={classes.dataCheck}/> */}
                                                                    {allCheckValue.length > 0 && allCheckValue[0].all == 1 ?
                                                                        <label className={classes.outerCheck}>
                                                                            <input type="checkbox" id={'all-Checkbox-' + getMidblockDatesData[0].Station_id} onChange={(e) => selectAllTypeCheckBox(e, getMidblockDatesData[0].Station_id)} />
                                                                            <span className="mark"></span>
                                                                        </label>
                                                                        : <label className={classes.outerCheck}>
                                                                            <input type="checkbox" id={'all-Checkbox-' + getMidblockDatesData[0].Station_id} onChange={(e) => selectAllTypeCheckBox(e, getMidblockDatesData[0].Station_id)} />
                                                                            <span className="mark"></span>
                                                                        </label>}
                                                                </TableCell>
                                                                <TableCell align="right" className={classes.dataTDCheckBox}>
                                                                    {allCheckValue.length > 0 && allCheckValue[0].volume == 1 ?
                                                                        <label className={classes.outerCheck}>
                                                                            <input type='checkbox' name='all-volume' value='all-volume' className={classes.dataCheck} id={'all-volume-' + getMidblockDatesData[0].Station_id} onChange={(e) => selectMidblockVolume(e, getMidblockDatesData[0].Station_id, getMidblockDatesData[0].station_type, getMidblockDatesData[0].mainDate)} checked={midVolValue == 1 ? true : false} />
                                                                            <span className="mark"></span>
                                                                        </label> : <Checkbox
                                                                            color="primary" className={classes.myCheckBox}
                                                                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                                            disabled />}
                                                                </TableCell>
                                                                <TableCell align="right" className={classes.dataTDCheckBox}>
                                                                    {allCheckValue.length > 0 && allCheckValue[0].class == 1 ?
                                                                        <label className={classes.outerCheck}>
                                                                            <input type='checkbox' name='all-class' value='all-class' className={classes.dataCheck} id={'all-class-' + getMidblockDatesData[0].Station_id} onChange={(e) => selectMidblockClass(e, getMidblockDatesData[0].Station_id, getMidblockDatesData[0].station_type, getMidblockDatesData[0].mainDate)} checked={midClassValue == 1 ? true : false} />
                                                                            <span className="mark"></span>
                                                                        </label> : <Checkbox
                                                                            color="primary" className={classes.myCheckBox}
                                                                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                                            disabled />}
                                                                </TableCell>
                                                                <TableCell align="right" className={classes.dataTDCheckBox}>
                                                                    {allCheckValue.length > 0 && allCheckValue[0].speed == 1 ?
                                                                        <label className={classes.outerCheck}>
                                                                            <input type='checkbox' name='all-speed' value='all-speed' className={classes.dataCheck} id={'all-speed-' + getMidblockDatesData[0].Station_id} onChange={(e) => selectMidblockSpeed(e, getMidblockDatesData[0].Station_id, getMidblockDatesData[0].station_type, getMidblockDatesData[0].mainDate)} checked={midSpeedValue == 1 ? true : false} />
                                                                            <span className="mark"></span>
                                                                        </label> : <Checkbox
                                                                            color="primary" className={classes.myCheckBox}
                                                                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                                            disabled />}
                                                                </TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell align="right" className={classes.tableHead}>Date</TableCell>
                                                                <TableCell align="right" className={classes.tableHead}>All</TableCell>
                                                                <TableCell align="right" className={classes.tableHead, classes.headIconBox} title='Volume'>
                                                                    <FontAwesomeIcon icon={faCar} className={classes.headIcon} title='Volume' style={{ cursor: 'pointer' }} />
                                                                </TableCell>
                                                                <TableCell align="right" className={classes.tableHead, classes.headIconBox} title='Class'>
                                                                    <FontAwesomeIcon icon={faTruck} className={classes.headIcon} title='Class' style={{ cursor: 'pointer' }} />
                                                                </TableCell>
                                                                <TableCell align="right" className={classes.tableHead, classes.headIconBox} title='Speed'>
                                                                    <FontAwesomeIcon icon={faTachometerAlt} className={classes.headIcon} title='Speed' style={{ cursor: 'pointer' }} />
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {getMidblockDatesData.map((getDates, index) => (
                                                                <StyledTableRow key={index}>
                                                                    <TableCell align="right" className={classes.dataTD}>{getDates.con_color == 'green' ? consiIndicator : getDates.con_color == 'blue' ? consiAltIndicator : consiGapIndicator}{getDates.date}</TableCell>

                                                                    <TableCell align="right" className={classes.dataTDCheckBox}>
                                                                        {getDates.volume == true || getDates.class == true || getDates.speed == true ?
                                                                            <label className={classes.outerCheck}>
                                                                                <input type='checkbox' name='all' value='all' className={classes.dataCheck} id={'all-' + getDates.Station_id + '-' + index} onChange={(e) => selectMidblockDataAll(e, getDates.Station_id, getDates.station_type, getDates.mainDate, getDates.consecutive_flag, getDates.consecutive_status, index, getDates.volume, getDates.class, getDates.speed)} />
                                                                                <span className="mark"></span>
                                                                            </label> :
                                                                            <Checkbox
                                                                                color="primary" className={classes.myCheckBox}
                                                                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                                                disabled />}
                                                                    </TableCell>
                                                                    <TableCell align="right" className={classes.dataTDCheckBox}>
                                                                        {getDates.volume == true ?
                                                                            <label className={classes.outerCheck}>
                                                                                <input type='checkbox' name='volume' value='volume' className={classes.dataCheck} id={'volume-' + getDates.Station_id + '-' + index} onChange={(e) => selectMidblockData(e, getDates.Station_id, getDates.station_type, getDates.mainDate, getDates.consecutive_flag, getDates.consecutive_status, index)} />
                                                                                <span className="mark"></span>
                                                                            </label>
                                                                            : <Checkbox
                                                                                color="primary" className={classes.myCheckBox}
                                                                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                                                disabled />}
                                                                    </TableCell>
                                                                    <TableCell align="right" className={classes.dataTDCheckBox}>
                                                                        {getDates.class == true ?
                                                                            <label className={classes.outerCheck}>
                                                                                <input type='checkbox' name='class' value='class' className={classes.dataCheck} id={'class-' + getDates.Station_id + '-' + index} onChange={(e) => selectMidblockData(e, getDates.Station_id, getDates.station_type, getDates.mainDate, getDates.consecutive_flag, getDates.consecutive_status, index)} />
                                                                                <span className="mark"></span>
                                                                            </label>
                                                                            : <Checkbox
                                                                                color="primary" className={classes.myCheckBox}
                                                                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                                                disabled />}
                                                                    </TableCell>
                                                                    <TableCell align="right" className={classes.dataTDCheckBox}>
                                                                        {getDates.speed == true ?
                                                                            <label className={classes.outerCheck}>
                                                                                <input type='checkbox' name='speed' value='speed' className={classes.dataCheck} id={'speed-' + getDates.Station_id + '-' + index} onChange={(e) => selectMidblockData(e, getDates.Station_id, getDates.station_type, getDates.mainDate, getDates.consecutive_flag, getDates.consecutive_status, index)} />
                                                                                <span className="mark"></span>
                                                                            </label>
                                                                            :
                                                                            <Checkbox
                                                                                color="primary" className={classes.myCheckBox}
                                                                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                                                disabled />}
                                                                        {index === getMidblockDatesData.length - 1 && getCheckHtml === 1 ? checkHeaderCheckBoxes(getDates.Station_id) : null}

                                                                    </TableCell>
                                                                </StyledTableRow>
                                                            ))
                                                            }
                                                        </TableBody>
                                                    </Table>
                                                    : <p>{noDataText}</p>}
                                            </TableContainer>
                                        </div>
                                        : <div>{stationTypeName}</div>}
                                {/* This html code for midblock */}
                            </div>
                            {consiCutiveStatus == 1 && stationTypeName == 1 ?
                                <div style={{ width: '100%', float: 'left', paddingBottom: '5px' }} disabled={false}>
                                    {getErrorHtml ? <p className={classes.selectedError}><FontAwesomeIcon icon={faExclamationCircle} />Please Select atleast one date ...!</p> : null}
                                    <FormControl component="fieldset" className={classes.formControl} style={{ marginTop: '-15px', marginBottom: '-5px' }}>
                                        <p style={{ width: '100%', float: 'left', margin: '0px', marginTop: '20px' }}>
                                            <label className={classes.outerCheck}>
                                                <input type='checkbox' name='consi-check' value='consi-check' className={classes.dataCheck} onChange={(e) => { selectConsecutiveDates(e) }} checked={exportAsSingleFile} />
                                                <span className="mark consiMark"></span><span className={classes.exportConsiCheckBox}>Export data for consecutive dates as a single file</span>
                                            </label>
                                        </p>
                                    </FormControl>
                                </div>
                                : null}
                        </fieldset>
                        <div className={classes.btnBlock}>
                            <button type='button' id='exportBact_btn' className={classes.exportBackBtn} onClick={backPageData} style={{ display: backPageBtn }} type='button'>Back</button>&nbsp;&nbsp;&nbsp;<button id='exportNext_btn' className={classes.exportNextBtn} onClick={nextPageData} type='button' style={{ display: nextPageBtn }}>Next</button>
                        </div>
                    </div>

                    <div className={classes.optionBock} style={{ display: optionStatus }}>
                        {getExportRequest.length && getExportRequest.length > 0 ?
                            <>
                                {intersectionStatus == 1 ? <div>
                                    <h4>Intersection Station Options</h4>
                                    <fieldset className={classes.fieldsetname}>
                                        <legend>Interval Options</legend>
                                        <FormControl component="fieldset">
                                            <RadioGroup row aria-label="interval_option" name="intersection_interval" value={intersectionInterval} name="interval_option" style={{ marginTop: '-15px', marginBottom: '-5px' }} onChange={(e) => intervalHandleChange(e)}>
                                                <p className={classes.intervalOptionBlock}>
                                                    <FormControlLabel
                                                        value={'15'}
                                                        control={<Radio color="primary" />}
                                                        label='15-minute intervals'
                                                    />
                                                </p>
                                                <p className={classes.intervalOptionBlock}>
                                                    <FormControlLabel
                                                        value={'5'}
                                                        control={<Radio color="primary" />}
                                                        label='5-minute intervals'
                                                    />
                                                </p>
                                            </RadioGroup>
                                        </FormControl>
                                    </fieldset>
                                </div> : null}
                                {intersectionStatus == 1 && midblockStatus == 1 ? <hr /> : null}
                                {midblockStatus == 1 ? <div>
                                    <h4>Midblock Station Options</h4>
                                    <fieldset className={classes.fieldsetname}>
                                        <legend>Interval Options</legend>
                                        <RadioGroup row aria-label="interval_option" name="interval_option" value={midblockInterval} style={{ marginTop: '-15px', marginBottom: '-5px' }} onChange={(e) => midblockHandleChange(e)}>
                                            <p className={classes.intervalOptionBlock}>
                                                <FormControlLabel
                                                    value={'60'}
                                                    control={<Radio color="primary" />}
                                                    label='60-minute intervals'
                                                />
                                            </p>
                                            <p className={classes.intervalOptionBlock}>
                                                <FormControlLabel
                                                    value={'15'}
                                                    control={<Radio color="primary" />}
                                                    label='15-minute intervals'
                                                />
                                            </p>
                                        </RadioGroup>
                                    </fieldset>
                                    <fieldset className={classes.fieldsetname}>
                                        <legend>Direction Options</legend>
                                        <FormControl component="fieldset" className={classes.formControl} style={{ marginTop: '-15px', marginBottom: '-5px' }}>
                                            <p className={classes.intervalOptionBlock}>
                                                <Checkbox
                                                    defaultChecked
                                                    color="primary"
                                                    value='Separate directions'
                                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                                    onChange={(e) => { checkOptionSeparately(e) }}
                                                />Separate directions
                                    </p>
                                            <p className={classes.intervalOptionBlock}>
                                                <Checkbox
                                                    defaultChecked
                                                    color="primary"
                                                    value='Combined'
                                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                                    onChange={(e) => { checkOptionCombined(e) }}
                                                />Combined
                                    </p>
                                        </FormControl>
                                    </fieldset>
                                </div> : null}
                            </> : null}
                        <div>{getIntersectionDatesData.length > 0 || getMidblockDatesData.length > 0 ? <></> : <p className={classes.selectedError} style={{ width: '100%' }}><FontAwesomeIcon icon={faExclamationCircle} />No Data available for Export ... !</p>}</div>
                        {optionCombined == false && optionSeparately == false ?
                            <p className={classes.selectedError}><FontAwesomeIcon icon={faExclamationCircle} />Please select at least one direction options&nbsp;!</p> : null}
                        <div className={classes.btnBlock}>
                            {getIntersectionDatesData.length > 0 || getMidblockDatesData.length > 0 ?
                                <>{getExportRequest.length && getExportRequest.length > 0 ?
                                    <><button type='button' id='exportBact_btn_1' className={classes.exportBackBtn} onClick={backPageData} style={{ display: backPageBtn }} type='button'>Back</button>&nbsp;&nbsp;&nbsp;{optionCombined == true || optionSeparately == true ? <button id='exportNext_btn_1' className={classes.exportNextBtn} onClick={optionNextBtn} type='button' style={{ display: nextPageBtn }}>Next</button> : <button type='button' id='nextMain_btn' className={classes.exportDisabledBtn} onClick={optionNextBtn} type='button' disabled>Next</button>}</> : <>
                                        <div style={{ marginTop: '-20px', }}><p className={classes.selectedError} style={{ display: errorDisplay, width: '100%', marginBottom: '20px', textAlign: 'left' }}><FontAwesomeIcon icon={faExclamationCircle} />Please select at least one date option for export&nbsp;!</p>
                                            <button type='button' id='exportBact_btn_1' className={classes.exportBackBtn} onClick={backPageData} style={{ display: errorDisplay }} type='button'>Back</button>
                                        </div>
                                    </>}</>
                                : <> <button id='close_block_btn' className={classes.exportNextBtn} onClick={props.checkExportValue} type='button' style={{ display: nextPageBtn }}>Close</button></>}
                        </div>
                    </div>
                    <div className={classes.dataBlock, classes.exportBlock} style={{ display: exportFormatBlock }}>
                        <fieldset className={classes.fieldsetname}>
                            <legend>Export Format</legend>
                            <FormControl component="fieldset" className={classes.formControl}>
                                <p className={classes.stationIdDataPara} style={{ marginTop: '0px', marginBottom: '10px' }}>
                                    <Checkbox
                                        defaultChecked
                                        color="primary"
                                        value='CSV'
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                        onChange={(e) => { exportToCsv(e) }}
                                    />CSV
                                    </p>
                            </FormControl>
                        </fieldset>
                        <p style={{ marginTop: '5px', marginBottom: '5px', color: '#CC0000' }}>{exportFailedError}</p>
                        <div className={classes.btnBlock}>
                            <button type='button' id='exportBact_btn' className={classes.exportBackBtn} onClick={optionBackBtn} type='button'>Back</button>&nbsp;&nbsp;&nbsp;{exportBtnStatus == true && getExportRequest.length && getExportRequest.length > 0 ? <button id='exportData_btn' className={classes.exportNextBtn} type='button' onClick={exportFile}>Export</button> : <button type='button' id='exportMain_btn' className={classes.exportDisabledBtn} onClick={exportFile} type='button' disabled>Export</button>}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment >
    )
}
export default ExportData;
//End ExportData component code ...
